import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Modal, Form, Tabs, Tab } from 'react-bootstrap';
import close from '../Asset/close.svg';
import { MultiSelect } from "react-multi-select-component";
import Alert from './Alert';
import Table_site from './tables/adminSiteTable';
import Table_user from './tables/adminUserTable';
import Table_shift from './tables/adminShiftTable';
import Table_ope from './tables/adminOpeTable';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import { environment } from './functions/environment';

function Asset_Customer_Form() {
    const navigate = useNavigate();
    //for reding url parameter
    let eqsrnoRef = useRef();
    let params = useParams();
    let opAssetRef = useRef();

    let userObj = getUserInfo();
    let [sessOut, setSessOut] = useState(false);
    let [userList, setUserList] = useState([]);
    let [userListDropdown, setUserListDropdown] = useState([]);
    let [siteList, setSiteList] = useState([]);
    let [soptions, setsoptions] = useState([]);
    let [shifts, setShifts] = useState([]);
    let [assetshifts, setAssetShifts] = useState([]);


    //////////////////////////////////For Account User Form Start//////////////////////////////////
    let [asset, setAsset] = useState({
        assetInfoID: "",
        assetID: "",
        model: "",
        deviceID: "",
        hourMeterReadingAtInstallation: "",
        hh: "",
        mm: "0",
        ss: "0",
        make: "",
        fuelType: "",
        comissioningDate: "",
        manufactureDate: "",
        isRental: null,
        subscriptionPlan: "",
        subscriptionTire: "",
        subscriptionStartDate: "",
        subscriptionEndDate: "",
        isRentalOfIoT: null,
        rentalOfIoTScheme: "",
        isActive: true,
        siteID: "",
        userID: [],
        shiftID: [],
        apiShiftID: [],
        productCategoryID: "",
        productSubCategoryID: "",
        accountID: "",
        accountName: "",
        opeType: "",
        apiSiteID: "",
        productDescription: "",
        frequency: "",
        warrantyDate: "",
        coverageDate: ""
    });
    let [assetApiShift, setAssetApiShift] = useState([]);
    let [assetApiUser, setAssetApiUser] = useState([]);
    //for reding url parameter
    useEffect(() => {
        if (params.assetInfoId) {
            let urlVar = JSON.parse(params.assetInfoId);
            // getAssetInfoFromID(urlVar.id, urlVar.type);//old version
            let opCode = params.opType == "01" ? "edit" : "copy";//01 = edit, 02 = copy
            getAssetInfoFromID(params.assetInfoId, opCode);//new version
        }
        else {

        }
    }, [])

    let [malert, setAlert] = useState({
        msg: "",
        status: false
    });

    const valueRenderer = (selected) => {
        let label = [];
        selected.map((item) =>
            label.push(item.label)
        )
        if (selected.length === 0) {
            return "Select"
        }
        else {
            return label.toString();
        }
    };

    function getShiftByEquipment(assetId) {
        fetch(environment.baseUrl + "getShiftByEquipment", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "assetID": assetId
            })
        }).then((apiRes) => {
            apiRes.json().then((res) => {
                if (res.code == 200) {
                    let temp = [], sid = [];
                    res.data.result.forEach(element => {
                        sid.push(element.shiftID);
                        temp.push({
                            label: element.shiftName,
                            value: element.shiftID,
                            startTime: (element.startTime).slice(11, 19),
                            endTime: (element.endTime).slice(11, 19)
                        })
                    });

                    setSelectShifts(temp);
                    setAsset({ ...asset, shiftID: sid });
                    setAssetApiShift(sid);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })
        })
    }
    function getUserByEquipment(assetId) {
        fetch(environment.baseUrl + "getUserByEquipment", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "assetID": assetId
            })
        }).then((apiRes) => {
            apiRes.json().then((res) => {
                if (res.code == 200) {
                    let temp = [], uid = [];
                    res.data.result.forEach(element => {
                        uid.push(element.userID);
                        temp.push({ label: element.firstName, value: element.userID })
                    });
                    setSelected(temp);
                    setAsset({ ...asset, userID: uid });
                    setAssetApiUser(uid);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })
        })
    }
    //for aseet get from url
    function getAssetInfoFromID(id, type) {
        fetch(environment.baseUrl + "asset-info/" + id, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                let hrArr = (resp.data.result[0].hourMeterReadingAtInstallation).split(":");
                if (type == "edit") {
                    setAsset({
                        ...asset,
                        assetInfoID: resp.data.result[0].assetInfoID,
                        assetID: resp.data.result[0].assetID,
                        model: resp.data.result[0].model,
                        deviceID: resp.data.result[0].deviceID,
                        hh: hrArr[0],
                        mm: hrArr[1] ? hrArr[1] : "00",
                        ss: hrArr[2] ? hrArr[2] : "00",
                        fuelType: resp.data.result[0].fuelType,
                        comissioningDate: resp.data.result[0].comissioningDate.slice(0, 10),
                        manufactureDate: resp.data.result[0].manufactureDate.slice(0, 10),
                        isRental: resp.data.result[0].isRental,
                        subscriptionPlan: resp.data.result[0].subscriptionPlan,
                        subscriptionTire: resp.data.result[0].subscriptionTire,
                        subscriptionStartDate: resp.data.result[0].subscriptionStartDate.slice(0, 10),
                        subscriptionEndDate: resp.data.result[0].subscriptionEndDate.slice(0, 10),
                        isRentalOfIoT: resp.data.result[0].isRentalOfIoT,
                        rentalOfIoTScheme: resp.data.result[0].rentalOfIoTScheme,
                        isActive: true,
                        siteID: resp.data.result[0].siteID,
                        apiSiteID: resp.data.result[0].siteID,
                        frequency: resp.data.result[0].frequency,
                        productDescription: resp.data.result[0].productDescription,
                        productCategoryID: resp.data.result[0].productCategoryID,
                        productSubCategoryID: resp.data.result[0].productSubCategoryID,
                        accountID: resp.data.result[0].accountID,
                        accountName: resp.data.result[0].accountName,
                        opeType: "edit",
                        warrantyDate: resp.data.result[0].warrantyDate ? resp.data.result[0].warrantyDate.slice(0, 10) : "",
                        coverageDate: resp.data.result[0].coverageDate ? resp.data.result[0].coverageDate.slice(0, 10) : ""
                    });
                    getAssetById(resp.data.result[0].assetID);
                    getShiftBySite(resp.data.result[0].siteID);
                    getUserBySiteID(resp.data.result[0].siteID);
                    getShiftByEquipment(resp.data.result[0].assetID);
                    getUserByEquipment(resp.data.result[0].assetID);
                }
                else if (type == "copy") {
                    setAsset({
                        ...asset,
                        model: resp.data.result[0].model,
                        make: resp.data.result[0].make,
                        fuelType: resp.data.result[0].fuelType,
                        frequency: resp.data.result[0].frequency,
                        productDescription: resp.data.result[0].productDescription,
                        comissioningDate: resp.data.result[0].comissioningDate.slice(0, 10),
                        manufactureDate: resp.data.result[0].manufactureDate.slice(0, 10),
                        isRental: resp.data.result[0].isRental,
                        subscriptionPlan: resp.data.result[0].subscriptionPlan,
                        subscriptionTire: resp.data.result[0].subscriptionTire,
                        subscriptionStartDate: resp.data.result[0].subscriptionStartDate.slice(0, 10),
                        subscriptionEndDate: resp.data.result[0].subscriptionEndDate.slice(0, 10),
                        isRentalOfIoT: resp.data.result[0].isRentalOfIoT,
                        rentalOfIoTScheme: resp.data.result[0].rentalOfIoTScheme,
                    });
                }
            })
        })
    }
    //in case of asset update distinguish between selected and unselected, user and shift
    function setAddRemoveItem() {
        let removeItem = assetApiShift.filter((o) => asset.shiftID.indexOf(o) === -1);
        let addItem = asset.shiftID.filter((o) => assetApiShift.indexOf(o) === -1);

        let removeUser = assetApiUser.filter((o) => asset.userID.indexOf(o) === -1);
        let addUser = asset.userID.filter((o) => assetApiUser.indexOf(o) === -1);
        return (
            {
                removeShiftID: removeItem,
                addShiftID: addItem,
                removeUserID: removeUser,
                addUserID: addUser
            }
        )
    }

    // asset form updation
    function updateAssetData() {
        let hh = asset.hh.length === 1 ? "0" + asset.hh : asset.hh;
        let mm = asset.mm.length === 1 ? "0" + asset.mm : asset.mm;
        let ss = asset.ss.length === 1 ? "0" + asset.ss : asset.ss;
        let shiftObj = setAddRemoveItem();
        fetch(environment.baseUrl + "updateAssetInfo/" + asset.assetInfoID, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                deviceID: asset.deviceID,
                fuelType: asset.fuelType,
                assetID: asset.assetID,
                addShiftID: shiftObj.addShiftID,
                removeShiftID: shiftObj.removeShiftID,
                make: asset.make,
                model: asset.model,
                comissioningDate: asset.comissioningDate,
                manufactureDate: asset.manufactureDate,
                subscriptionStartDate: asset.subscriptionStartDate,
                subscriptionEndDate: asset.subscriptionEndDate,
                subscriptionPlan: asset.subscriptionPlan,
                subscriptionTire: asset.subscriptionTire,
                siteID: asset.siteID,
                hourMeterReadingAtInstallation: hh + ":" + mm + ":" + ss,
                addUserID: shiftObj.addUserID,
                removeUserID: shiftObj.removeUserID,
                isRentalOfIoT: asset.isRentalOfIoT,
                rentalOfIoTScheme: asset.rentalOfIoTScheme,
                productDescription: asset.productDescription,
                frequency: asset.frequency,
                warrantyDate: asset.warrantyDate,
                coverageDate: asset.coverageDate
            })
        }).then((result) => {
            result.json().then((res) => {
                if (res.code == 200) {
                    navigate('/assets-lists');
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                setAlert({
                    msg: res.msg,
                    status: true
                });
            })
        })
    }
    // asset updation

    let [dropdownData, setDropDownData] = useState({
        asset_productCategory: [
            { name: "" },
        ],
        asset_productSubCategory: [
            { name: "" },
        ],
        asset_Model: [
            { name: "" },
        ],
        asset_equipmentType: [
            { name: "" },
        ]
    });

    //for asset form user multiselect 
    const [selected, setSelected] = useState([]);
    useEffect(() => {
        let arr = [], shiftList = shifts;
        selected.map(e => (arr.push(e.value)));
        setAsset({ ...asset, userID: arr });


    }, [selected])

    //for asset form shift multiselect 
    const [shiftOverlap, setShiftOverlap] = useState(false);
    const [selectShifts, setSelectShifts] = useState([]);
    useEffect(() => {
        let sarr = [];
        selectShifts.map(e => (sarr.push(e.value)));
        setAsset({ ...asset, shiftID: sarr });

        checkShiftTimeOverlap();
        if (selectShifts.length == 0) {
            setShiftOverlap(false);
        }
    }, [selectShifts])


    //this function tack care that user should not select overlaped shift  
    function checkShiftTimeOverlap() {
        let date = "2022-01-01 ";
        let dateNext = "2022-01-02 ";
        let list = assetshifts;

        list.forEach((element, i) => {
            let elementStaus = false;
            let mstart = date + element.startTime;
            let mend = date + element.endTime;

            if (mstart > mend) {
                mend = dateNext + element.endtime;
            }

            selectShifts.forEach((eleIn) => {
                let sstart = date + eleIn.startTime;
                let send = date + eleIn.endTime;
                if (sstart > send) {
                    send = dateNext + eleIn.endtime;
                }

                if (element.value != eleIn.value) {
                    if (mstart >= sstart && mstart <= send) {
                        elementStaus = true;
                    }
                    else if (mend >= sstart && mend <= send) {
                        elementStaus = true;
                    }
                    else if (sstart >= mstart && sstart <= mend) {
                        elementStaus = true;
                    }
                    else if (send >= mstart && send <= mend) {
                        elementStaus = true;
                    }

                    if (element.startTime >= eleIn.startTime && element.startTime <= eleIn.endTime) {
                        elementStaus = true;
                    }
                    else if (element.endTime >= eleIn.startTime && element.endTime <= eleIn.endTime) {
                        elementStaus = true;
                    }
                    else if (eleIn.startTime >= element.startTime && eleIn.startTime <= element.endTime) {
                        elementStaus = true;
                    }
                    else if (eleIn.endTime >= element.startTime && eleIn.endTime <= element.endTime) {
                        elementStaus = true;
                    }
                }
            });
            if (elementStaus) {
                list[i].disabled = true;
                setShiftOverlap(true);
            } else {
                list[i].disabled = false;
            }
        });
    }
    //for multiselect end
    let [assetIdData, setassetIdData] = useState({
        accountID: "",
        accountName: "",
        assetID: "",
        assetMasterID: null,
        createdDateTime: null,
        industry: "",
        isActivce: true,
        isKeyAccount: "",
        model: "",
        salesBranch: "",
        serviceBranch: "",
        serviceDealer: "",
        updatedDateTime: null,
        serviceBranchID: "",
        salesBranchID: "",
        assetExist: ""
    })
    function getAccountUserList() {
        fetch(environment.baseUrl + "listAccountUsers?", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        })
            .then((apiRes) => {
                apiRes.json().then((resp) => {
                    setsoptions([]);
                    setUserList(resp.data.result);
                    userList.map((item) =>
                        setsoptions((oldVal) => [...oldVal, { value: item.userID, label: item.firstName }])
                    )
                })
            })
    }

    function getAssetById(id, did) {
        if (id !== "") {
            fetch(environment.baseUrl + "assetMasterByIDnew?", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userObj.token
                },
                body: JSON.stringify({
                    "assetID": id,
                })
            }).then((apiRes) => {
                apiRes.json().then((resp) => {
                    if (resp.code === 200) {
                        if (resp.data.result.assetInfo) {
                            setassetIdData({
                                accountID: resp.data.result.assetInfo.accountID,
                                accountName: resp.data.result.assetInfo.accountName,
                                assetID: resp.data.result.assetInfo.assetID,
                                assetMasterID: resp.data.result.assetInfo.assetMasterID,
                                createdDateTime: resp.data.result.assetInfo.createdDateTime,
                                industry: resp.data.result.assetInfo.industry,
                                isActivce: resp.data.result.assetInfo.isActivce,
                                isKeyAccount: resp.data.result.assetInfo.isKeyAccount,
                                salesBranch: resp.data.result.assetInfo.salesBranch,
                                serviceBranch: resp.data.result.assetInfo.serviceBranch,
                                serviceDealer: resp.data.result.assetInfo.serviceDealer,
                                updatedDateTime: resp.data.result.assetInfo.updatedDateTime,
                                productCategory: resp.data.result.assetInfo.productCategory,
                                productSubCategory: resp.data.result.assetInfo.productSubCategory,
                                productCategoryID: resp.data.result.assetInfo.productCategoryID,
                                productSubCategoryID: resp.data.result.assetInfo.productSubCategoryID,
                                serviceBranchID: resp.data.result.assetInfo.serviceBranchID,
                                salesBranchID: resp.data.result.assetInfo.salesBranchID,
                                assetExist: resp.data.result.assetExist
                            })
                            //for Account User
                            setInfo({ ...info, accountID: (resp.data.result.assetInfo).accountID });
                            sessionStorage.setItem('assetID', JSON.stringify((resp.data.result.assetInfo).assetID));
                            sessionStorage.setItem('accountID', JSON.stringify((resp.data.result.assetInfo).accountID))
                            if (!params.assetInfoId) {
                                setShifts([]);
                            }
                            getProductDescription(resp.data.result.assetInfo.productCategoryID, resp.data.result.assetInfo.productSubCategoryID);
                            setlistAllPM([]);
                            getSiteList();
                            getEquipmentByAccount();
                            getUserByAccID();
                            getOperatorByAcc();
                            getShiftForOpoerator();
                            listPM();
                            getGroupByAccount((resp.data.result.assetInfo).accountID);
                            getThreshold((resp.data.result.assetInfo).accountID, (resp.data.result.assetInfo).assetID, (resp.data.result.assetInfo).productSubCategoryID);
                            setTabClass("tab-menu");

                        }
                        else {
                            setassetIdData({
                                accountID: "",
                                accountName: "",
                                assetID: "",
                                assetMasterID: null,
                                createdDateTime: null,
                                industry: "",
                                isActivce: true,
                                isKeyAccount: "",
                                salesBranch: "",
                                serviceBranch: "",
                                serviceDealer: "",
                                updatedDateTime: null,
                                productCategory: "",
                                productSubCategory: "",
                                productCategoryID: "",
                                productSubCategoryID: "",
                                serviceBranchID: "",
                                salesBranchID: "",
                                assetExist: "no"
                            })

                        }
                    }
                    else if (resp.code == 401) {
                        setSessOut(true);
                    }
                    else {
                        setAlert({
                            msg: resp.msg,
                            status: true
                        });
                    }
                })
            })
        }
    }
    function getDropDown() {
        fetch(environment.baseUrl + "getDropDown", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "groupName": ["productCategory", "productSubCategory", "equipmentType", "model"],
                "masterType": ["asset"]
            })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setDropDownData(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setDropDownData({
                        asset_Model: [
                            { name: "" },
                        ],
                        asset_equipmentType: [
                            { name: "" },
                        ]
                    })
                }
            })
        })
    }

    let [productDescription, setProductDescription] = useState([]);
    function getProductDescription(category, subCategory) {

        fetch(environment.baseUrl + 'getProductDescription', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    productCategoryID: category,
                    productSubCategoryID: subCategory
                }

            )
        }).then((res) => {
            res.json().then((resp) => {
                if (resp.code == 200) {
                    setProductDescription(resp.data.result.categories);

                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setProductDescription([]);
                }
            })
        })
    }
    function getAssetFormData(e) {
        if (e.target.name === 'siteID' || e.target.name === 'shiftID') {
            setAsset({ ...asset, [e.target.name]: parseInt(e.target.value), userID: [] });
            if (e.target.name === 'siteID') {
                setSelectShifts([]);
                setSelected([]);
                if (e.target.value) {
                    getShiftBySite(parseInt(e.target.value));
                    getUserBySiteID(parseInt(e.target.value));
                }
                else {
                    setShifts([]);
                    setuserBySite([]);
                }
                setAssetError(false);
            }
        }
        else if (e.target.name === 'isRental' || e.target.name === "isRentalOfIoT") {
            setAsset({ ...asset, [e.target.name]: parseInt(e.target.value) });
        }
        else if (e.target.name === "deviceID") {
            setAsset({ ...asset, [e.target.name]: e.target.value });
            checkDeviceID(e.target.value);
        }
        else {
            setAsset({ ...asset, [e.target.name]: e.target.value });
            if (e.target.name === "assetID") {
                getAssetById(e.target.value);
                setAssetError(false);
            }
        }
        setAssetError(false);
    }
    let [deviceExist, setDeviceExist] = useState(false);
    function checkDeviceID(dId) {
        fetch(environment.baseUrl + 'deviceIDExists?', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({ "deviceID": dId })
        }).then((res) => {
            res.json().then((resp) => {
                setDeviceExist(resp.data.result.deviceExist);
            })
        })
    }

    let [assetError, setAssetError] = useState("");
    function saveAssetFrom(e) {
        let hh = asset.hh.length === 1 ? "0" + asset.hh : asset.hh;
        let mm = asset.mm.length === 1 ? "0" + asset.mm : asset.mm;
        let ss = asset.ss.length === 1 ? "0" + asset.ss : asset.ss;
        setAssetError(false);
        fetch(environment.baseUrl + "addasset", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                assetInfoID: asset.assetInfoID,
                assetID: asset.assetID,
                model: asset.model,
                deviceID: asset.deviceID,
                hourMeterReadingAtInstallation: hh + ":" + mm + ":" + ss,
                make: asset.make,
                fuelType: asset.fuelType,
                comissioningDate: asset.comissioningDate,
                manufactureDate: asset.manufactureDate,
                isRental: asset.isRental,
                subscriptionPlan: asset.subscriptionPlan,
                subscriptionTire: asset.subscriptionTire,
                subscriptionStartDate: asset.subscriptionStartDate,
                subscriptionEndDate: asset.subscriptionEndDate,
                isRentalOfIoT: asset.isRentalOfIoT,
                rentalOfIoTScheme: asset.rentalOfIoTScheme,
                isActive: asset.isActive,
                siteID: asset.siteID,
                userID: asset.userID,
                shiftID: asset.shiftID,
                productDescription: asset.productDescription,
                frequency: asset.frequency,
                productCategoryID: assetIdData.productCategoryID,
                productSubCategoryID: assetIdData.productSubCategoryID,
                accountID: assetIdData.accountID,
                accountName: assetIdData.accountName,
                serviceBranchID: assetIdData.serviceBranchID,
                salesBranchID: assetIdData.salesBranchID,
                warrantyDate: asset.warrantyDate,
                coverageDate: asset.coverageDate
            })
        }).then((result) => {
            result.json().then((res) => {
                if (res.code == 200) {
                    resetAssetForm();
                    setAlert({
                        msg: res.msg,
                        status: true,
                        type: "custom",
                        catId: assetIdData.productSubCategoryID
                    });
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })
        })
    }
    function getShiftBySite(siteId) {
        setSelectShifts([]);
        fetch(environment.baseUrl + "getShiftBySite", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "siteID": siteId,
            })
        }).then((result) => {
            result.json().then((res) => {
                if (res.code == 200) {
                    let arr = [];
                    setShifts(res.data.result);
                    res.data.result.map((item) =>
                        arr.push({
                            label: item.shiftName,
                            value: item.shiftID,
                            startTime: (item.startTime).slice(11, 19),
                            endTime: (item.endTime).slice(11, 19)
                        })
                    )
                    setAssetShifts(arr);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setShifts([]);
                    setAssetShifts([]);
                }
            })
        })
    }
    function resetAssetForm() {
        setAsset({
            assetInfoID: "",
            assetID: "",
            model: "",
            deviceID: "",
            hourMeterReadingAtInstallation: "",
            hh: "",
            mm: "00",
            ss: "00",
            make: "",
            fuelType: "",
            comissioningDate: "",
            manufactureDate: "",
            isRental: null,
            subscriptionPlan: "",
            subscriptionTire: "",
            subscriptionStartDate: "",
            subscriptionEndDate: "",
            isRentalOfIoT: null,
            rentalOfIoTScheme: "",
            isActive: true,
            siteID: "",
            userID: [],
            shiftID: [],
            productCategoryID: "",
            productSubCategoryID: "",
            accountID: "",
            accountName: "",
            productDescription: "",
            frequency: ""
        });
        setassetIdData({
            accountID: "",
            accountName: "",
            assetID: "",
            assetMasterID: null,
            createdDateTime: "",
            industry: "",
            isActivce: true,
            isKeyAccount: "",
            salesBranch: "",
            serviceBranch: "",
            serviceDealer: "",
            updatedDateTime: "",
            productCategory: "",
            productSubCategory: "",
            productCategoryID: "",
            productSubCategoryID: "",
            serviceBranchID: "",
            salesBranchID: "",
            assetExist: false
        });
        setSiteList([]);
        setuserBySite([]);
        setShifts([]);
        setSelectShifts([]);
        setSelected([]);
    }
    //////////////////////////////////For Account User Form End//////////////////////////////////

    let [equipmentByAccount, setequipmentByAccount] = useState([]);
    function getEquipmentByAccount() {
        let accID = JSON.parse(sessionStorage.getItem("accountID"))
        fetch(environment.baseUrl + "getEquipmentByAccount?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "accountID": accID
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setequipmentByAccount(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setequipmentByAccount([]);
                }
            })
        })
    }

    //////////////////////////////////For Account User Start//////////////////////////////////
    let [info, setInfo] = useState({
        accountID: "",
        siteID: null,
        roleID: null,
        firstName: "",
        lastName: "",
        mobileNo: "",
        emailID: "",
        groupID: "",
        userType: "account_user",
        userID: null,
        isActive: true,
        optype: ""
    });

    let [userByAccount, setuserByAccount] = useState([]);

    let [allRole, setAllRow] = useState([]);
    function getAllRoles() {
        fetch(environment.baseUrl + "customerRoles?", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((result) => {
            result.json().then((res) => {
                if (res.code == 200) {
                    setAllRow(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setAllRow([]);
                }
            })
        })
    }

    function getUserByAccID() {
        fetch(environment.baseUrl + "getUserByAccID?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "accountID": JSON.parse(sessionStorage.getItem('accountID')),
                "userType": "account_user"
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setuserByAccount(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setuserByAccount([]);
                }
            })
        })
    }
    let [userBySite, setuserBySite] = useState([]);
    function getUserBySiteID(sid) {
        setSelected([]);
        fetch(environment.baseUrl + "getUserBySite?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                siteID: sid
            })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setuserBySite(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setuserBySite([]);
                }
            })
        })
    }

    function getAccountUserFormData(e) {
        if (e.target.name === "roleID") {
            setInfo({ ...info, [e.target.name]: parseInt(e.target.value) });
        }
        else {
            setInfo({ ...info, [e.target.name]: e.target.value });
        }
    }

    let [addUserShow, setAddUserShow] = useState(false);
    function setAddUserModel() {
        setAddUserShow(true);
    }
    let handleAddUserClose = () => {
        setErrorMsg({})
        setAddUserShow(false);
        setInfo({
            accountID: "",
            siteID: null,
            roleID: null,
            firstName: "",
            lastName: "",
            mobileNo: "",
            emailID: "",
            groupID: "",
            userID: null,
            userType: "account_user",
            isActive: true,
            optype: ""
        })
    };

    let [accountUserError, setAccountUserError] = useState("");

    function saveAccountUserForm(e) {
        if (info.roleID && info.firstName && info.lastName && info.mobileNo && info.emailID) {
            fetch(environment.baseUrl + "usersRegistration", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userObj.token
                },
                body: JSON.stringify({
                    accountID: assetIdData.accountID,
                    siteID: info.siteID,
                    roleID: info.roleID,
                    firstName: info.firstName,
                    lastName: info.lastName,
                    mobileNo: info.mobileNo,
                    emailID: info.emailID,
                    groupID: info.groupID,
                    userType: info.userType,
                    isActive: true
                })
            }).then((result) => {
                result.json().then((res) => {
                    if (res.code == 200) {
                        getUserByAccID();
                        if (parseInt(info.siteID) === asset.siteID) {
                            getUserBySiteID(asset.siteID);
                            if (asset.opeType === "edit") {
                                if (asset.apiSiteID === asset.siteID) {
                                    getUserByEquipment(asset.assetID);
                                }
                            }
                        }
                    }

                    let errror = {};
                    if (res.msg == "EmailID already exist.") {

                        errror.emailID = res.msg;
                        setErrorMsg(errror);
                    }
                    else if (res.code == 200) {
                        setAlert({
                            msg: res.msg,
                            status: true
                        });
                        handleAddUserClose();
                    }
                    else if (res.code == 401) {
                        setSessOut(true);
                    }
                })
            })
        }
        else {
            setAlert({
                msg: "Please Fill All Details",
                status: true
            });
        }
    }

    function editAccountUser(currentObj) {
        setInfo({
            ...info,
            accountID: currentObj.accountID,
            roleID: currentObj.roleID,
            firstName: currentObj.firstName,
            lastName: currentObj.lastName,
            mobileNo: currentObj.phoneNumber,
            emailID: currentObj.emailID,
            groupID: currentObj.groupID,
            userID: currentObj.userID,
            siteID: currentObj.siteID,
            optype: "edit",
            isActive: currentObj.isActive ? "true" : "false"
        })
        setAddUserShow(true);
    }
    let [showudashName, setShowUdashName] = useState(false);
    let [udashName, setUdashName] = useState({
        userName: "",
        data: []
    });
    function showUsersDashboardName(currentObj) {
        fetch(environment.baseUrl + "getDashboardByUserWeb", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                userID: currentObj.userID
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setUdashName({ userName: currentObj.firstName + " " + currentObj.lastName, data: resp.data.result });
                    setShowUdashName(true);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setUdashName({
                        userName: "",
                        data: []
                    })
                }
            })
        })
    }
    function updateAccountUser() {
        fetch(environment.baseUrl + "updateUser", {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                roleID: info.roleID,
                firstName: info.firstName,
                lastName: info.lastName,
                userID: info.userID,
                phoneNumber: info.mobileNo,
                groupID: info.groupID,
                isActive: info.isActive
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    getUserByAccID();
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                handleAddUserClose();
                setAlert({
                    msg: resp.msg,
                    status: true
                });
            })
        })
    }
    const [dashboardGroupList, setDashboardGroupList] = useState([]);
    function getGroupByAccount(accID) {
        fetch(environment.baseUrl + "getGroupByAccount?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "accountID": accID
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    let temp = []
                    resp.data.result.map((item) =>
                        temp.push({
                            accountiD: item.accountID,
                            groupName: item.groupName,
                            groupID: item.groupID
                        })
                    )
                    setDashboardGroupList(temp);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setDashboardGroupList([]);
                }
            })
        })
    }
    //////////////////////////////////For Account User End//////////////////////////////////




    ///////////////////////////////////////////for Threshold start///////////////////////////////////////////////////////
    let [threshold, setThreshold] = useState({
        accountID: "",
        assetID: "",
        targetUtilization: "",
        fuelLevel: "",
        isActive: true,
        batteryLevel: "",
        coolentTemprature: "",
        voltMeter: "",
        engineOilPressure: "",
        minEOP: "",
        minCT: "",
        gForce: "",
        readOnly: false,
        updateBtn: false,
    });

    function getThresholdFormData(e) {
        // console.log(e.target.name, typeof e.target.value);
        setThreshold({ ...threshold, [e.target.name]: e.target.value });
    }
    // GET THRESHOLD
    function getThreshold(accountID, assetID, psubID) {
        if (assetID && accountID) {
            fetch(environment.baseUrl + 'getThresholdData?', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userObj.token
                },
                body: JSON.stringify({
                    "assetID": assetID,
                    "accountID": accountID
                })
            }).then((result) => {
                result.json().then(res => {
                    if (res.code == 200) {
                        if (res.data.result.length) {
                            res.data.result.map((item) => {
                                setThreshold({
                                    accountID: item.accountID,
                                    assetID: item.assetID,
                                    targetUtilization: item.targetUtilization,
                                    fuelLevel: item.fuelLevel,
                                    isActive: true,
                                    batteryLevel: item.batteryLevel,
                                    coolentTemprature: item.maxCT,
                                    voltMeter: item.voltMeter,
                                    engineOilPressure: item.maxEOP,
                                    gForce: item.gForce,
                                    minEOP: item.minEOP ? item.minEOP : 0,
                                    minCT: item.minCT ? item.minCT : 0,
                                    readOnly: true,
                                    updateBtn: true
                                })
                            })
                        }
                        else {
                            getThresholdBySubCat(psubID);
                        }
                    }
                    else if (res.code == 401) {
                        setSessOut(true);
                    }
                    else {
                        setThreshold({
                            accountID: "",
                            assetID: "",
                            targetUtilization: "",
                            fuelLevel: "",
                            isActive: true,
                            batteryLevel: "",
                            coolentTemprature: "",
                            voltMeter: "",
                            engineOilPressure: "",
                            readOnly: false,
                            updateBtn: false,
                            gForce: "",
                            minEOP: "",
                            minCT: ""
                        })
                    }
                })
            })
        }
    }

    function getThresholdBySubCat(id) {

        fetch(environment.baseUrl + "getThresholdBySubCategory", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "productSubCategoryID": id,
            })
        }).then((result) => {
            result.json().then((res) => {
                if (res.code == 200) {
                    setThreshold({
                        targetUtilization: res.data.result[0].targetUtilization,
                        fuelLevel: res.data.result[0].fuelLevel,
                        isActive: true,
                        batteryLevel: res.data.result[0].batteryLevel,
                        voltMeter: res.data.result[0].voltMeter,
                        readOnly: false,
                        updateBtn: false,
                        gForce: res.data.result[0].gForce,
                        minEOP: res.data.result[0].minEOP,
                        minCT: res.data.result[0].minCT,
                        coolentTemprature: res.data.result[0].maxCT,
                        engineOilPressure: res.data.result[0].maxEOP,
                    })
                }
                else {
                    setThreshold({
                        targetUtilization: "",
                        fuelLevel: "",
                        isActive: true,
                        batteryLevel: "",
                        voltMeter: "",
                        readOnly: false,
                        updateBtn: false,
                        gForce: "",
                        minEOP: "",
                        minCT: ""
                    })
                }
            })
        })
    }
    let [tsErrorMsg, setTsErrorMsg] = useState({});
    function validateTsData() {
        let errror = {};

        if (threshold.targetUtilization == "") {
            errror.targetUtilization = "This field is required";
        } else if (parseInt(threshold.targetUtilization) < 0 || parseInt(threshold.targetUtilization) > 100) {
            errror.targetUtilization = "Enter value between 0-100";
        }

        if (threshold.fuelLevel == "") {
            errror.fuelLevel = "This field is required";
        } else if (parseInt(threshold.fuelLevel) < 0 || parseInt(threshold.fuelLevel) > 100) {
            errror.fuelLevel = "Enter value between 0-100";
        }

        if (threshold.batteryLevel == "") {
            errror.batteryLevel = "This field is required";
        } else if (parseInt(threshold.batteryLevel) < 0 || parseInt(threshold.batteryLevel) > 100) {
            errror.batteryLevel = "Enter value between 0-100";
        }

        if (threshold.coolentTemprature == "") {
            errror.coolentTemprature = "This field is required";
        } else if (parseInt(threshold.coolentTemprature) < 0) {
            errror.coolentTemprature = "Enter only positive number";
        }

        if (threshold.minCT == "") {
            errror.minCT = "This field is required";
        } else if (parseInt(threshold.minCT) < 0) {
            errror.minCT = "Enter only positive number";
        }

        if (threshold.voltMeter == "") {
            errror.voltMeter = "This field is required";
        } else if (parseInt(threshold.voltMeter) < 0) {
            errror.voltMeter = "Enter only positive number";
        }

        if (threshold.engineOilPressure == "") {
            errror.engineOilPressure = "This field is required";
        } else if (parseInt(threshold.engineOilPressure) < 0) {
            errror.engineOilPressure = "Enter only positive number";
        }

        if (threshold.minEOP == "") {
            errror.minEOP = "This field is required";
        } else if (parseInt(threshold.minEOP) < 0) {
            errror.minEOP = "Enter only positive number";
        }

        if (threshold.gForce == "") {
            errror.gForce = "This field is required";
        } else if (parseInt(threshold.gForce) < 0) {
            errror.gForce = "Enter only positive number";
        }

        setTsErrorMsg(errror);

        if (Object.keys(errror).length == 0) {
            if (threshold.updateBtn) {
                updateThresholdFrom();
            }
            else {
                saveThresholdFrom();
            }
        }
        else {
        }
    }

    // PUT THRESHOLD
    function updateThresholdFrom() {
        fetch(environment.baseUrl + 'updateThresholdData?', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                accountID: JSON.parse(sessionStorage.getItem('accountID')),
                assetID: JSON.parse(sessionStorage.getItem('assetID')),
                batteryLevel: parseFloat(threshold.batteryLevel),
                coolentTemprature: parseFloat(threshold.coolentTemprature),
                engineOilPressure: parseFloat(threshold.engineOilPressure),
                fuelLevel: parseFloat(threshold.fuelLevel),
                isActive: threshold.isActive,
                targetUtilization: parseFloat(threshold.targetUtilization),
                voltMeter: parseFloat(threshold.voltMeter),
                gForce: threshold.gForce,
                minEOP: parseFloat(threshold.minEOP),
                minCT: parseFloat(threshold.minCT)
            })
        }).then((result) => {
            result.json().then(res => {
                setAlert({
                    msg: res.msg,
                    status: true
                });
                if (res.code == 200) {
                    setThreshold({ ...threshold, readOnly: true })
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })
        })
    }

    function saveThresholdFrom() {
        fetch(environment.baseUrl + 'addThresholdData?', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                accountID: JSON.parse(sessionStorage.getItem('accountID')),
                assetID: JSON.parse(sessionStorage.getItem('assetID')),
                batteryLevel: parseFloat(threshold.batteryLevel),
                coolentTemprature: parseFloat(threshold.coolentTemprature),
                engineOilPressure: parseFloat(threshold.engineOilPressure),
                fuelLevel: parseFloat(threshold.fuelLevel),
                isActive: threshold.isActive,
                targetUtilization: parseFloat(threshold.targetUtilization),
                voltMeter: parseFloat(threshold.voltMeter),
                gForce: (threshold.gForce).toString(),
                minEOP: parseFloat(threshold.minEOP),
                minCT: parseFloat(threshold.minCT)
            })
        }).then((result) => {
            result.json().then(res => {
                setAlert({
                    msg: res.msg,
                    status: true
                });
                setThreshold({ ...threshold, readOnly: true, updateBtn: true })

            })
        })

    }

    // clear THRESHOLD
    function clearThreshold() {
        setThreshold({ ...threshold, readOnly: true })
    }
    ///////////////////////////////////////////for Threshold end///////////////////////////////////////////////////////


    useEffect(() => {
        getDropDown();
    }, [])


    ////////////////////////////////////////for save site start//////////////////////////////////////////
    let [site, setSite] = useState({
        accountID: "",
        siteID: null,
        siteName: "",
        workDay: [],
        isActive: true,
        opeType: "",
        apiSelect: [],
        userSelect: []
    });

    let [addSiteShow, setAddSiteShow] = useState(false);
    function setAddSiteModel() {
        setAddSiteShow(true);
    }
    let handleAddSiteClose = () => {
        setAccAssociatederrorMsg({})
        setAddSiteShow(false);
        setSite({
            accountID: "",
            siteID: null,
            siteName: "",
            workDay: [],
            isActive: true,
            opeType: "",
            apiSelect: [],
            userSelect: []
        });
        setSelectedDay([]);
    };

    const daysArr = [
        { label: "Monday", value: "Monday" },
        { label: "Tuesday", value: "Tuesday" },
        { label: "Wednesday", value: "Wednesday" },
        { label: "Thursday", value: "Thursday" },
        { label: "Friday", value: "Friday" },
        { label: "Saturday", value: "Saturday" },
        { label: "Sunday", value: "Sunday" }
    ];

    const [selectedDay, setSelectedDay] = useState([]);
    useEffect(() => {
        let arr = [], temp = [];
        selectedDay.forEach(element => {
            temp.push(element.label);
            arr.push({ day: element.label, isWorkingDay: 1 })
        });

        daysArr.forEach(element => {
            if (temp.indexOf(element.label) === -1) {
                arr.push({ day: element.label, isWorkingDay: 0 })
            }
        });
        setSite({ ...site, workDay: arr, userSelect: temp });

    }, [selectedDay])

    function saveSite(e) {
        let accID = JSON.parse(sessionStorage.getItem("accountID"));
        if (site.siteName !== "" || site.siteName !== " ") {
            fetch(environment.baseUrl + "addSite?", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userObj.token
                },
                body: JSON.stringify({
                    accountID: accID,
                    siteName: site.siteName,
                    workDay: site.workDay
                })
            }).then((result) => {
                result.json().then(res => {
                    handleAddSiteClose();
                    //alert(res.msg);
                    setAlert({
                        msg: res.msg,
                        status: true
                    });
                    if (res.code == 200) {
                        getSiteList();
                    }
                    else if (res.code == 401) {
                        setSessOut(true);
                    }
                })
            })
        }
        else {
            alert("Please enter site name");
        }
    }
    let [workDays, setWorkDays] = useState([]);

    let [showDays, setShowDays] = useState(false);

    function showWorkDays(siteID) {
        fetch(environment.baseUrl + "getScheduleTimeBySite?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                siteID: siteID
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setWorkDays(resp.data.result)
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setWorkDays([]);
                }
            })
        })
        setShowDays(true);
    }
    function getSiteList() {
        let accID = JSON.parse(sessionStorage.getItem("accountID"))
        fetch(environment.baseUrl + "getSiteByAccID?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "accountID": accID
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setSiteList(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setSiteList([]);
                }
            })
        })
    }

    function editSite(currentObj) {
        let temp = [];
        sessionStorage.setItem("siteNameCheck", currentObj.siteName);
        fetch(environment.baseUrl + "getScheduleTimeBySite?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                siteID: currentObj.siteID
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                let arr = [];
                resp.data.result.forEach(element => {
                    temp.push(element.workingDay);
                    arr.push({ label: element.workingDay, value: element.workingDay })
                });
                setSelectedDay(arr);
            })
        })


        setSite({
            ...site,
            accountID: currentObj.accountID,
            siteID: currentObj.siteID,
            siteName: currentObj.siteName,
            opeType: "edit",
            apiSelect: temp,
        })

        setWorkDays(site.workDay);
        setAddSiteShow(true);
    }
    function setAddRemoveDays() {
        let removeItem = site.apiSelect.filter((o) => site.userSelect.indexOf(o) === -1);
        let addItem = site.userSelect.filter((o) => site.apiSelect.indexOf(o) === -1);
        return (
            {
                removeDay: removeItem,
                addDay: addItem
            }
        )
    }
    function updateSite() {
        let obj = setAddRemoveDays();
        let oldName = sessionStorage.getItem("siteNameCheck");

        fetch(environment.baseUrl + "updateSite?", {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                siteID: site.siteID,
                siteName: site.siteName.localeCompare(oldName) === 0 ? "" : site.siteName,
                removeDays: obj.removeDay,
                addDays: obj.addDay,
                accountID: assetIdData.accountID
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                handleAddSiteClose();
                setAlert({
                    msg: resp.msg,
                    status: true
                });
                if (resp.code == 200) {
                    getSiteList();
                    sessionStorage.removeItem("siteNameCheck");
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
            })
        })
    }

    let [accAssociatederrorMsg, setAccAssociatederrorMsg] = useState({});
    function accAssociatedValidate() {
        let errror = {};
        if (site.siteName == "") {
            errror.siteName = "This field is required";
        }
        if (site.siteName.length > 25) {
            errror.siteName = "Exceeded 25 character limits";
        }
        if (selectedDay.length == 0) {
            errror.workDay = "This field is required";
        }
        setAccAssociatederrorMsg(errror);
        if (Object.keys(errror).length == 0) {
            if (site.opeType == "edit") {
                updateSite();
            }
            else {
                saveSite();
            }
        }
    }
    ////////////////////////////////////////for save site end//////////////////////////////////////////


    // =======================================================
    //                  SHIFT 
    // ======================================================
    const format = 'h:mm a';
    const now = moment().hour(0).minute(0);
    function addShiftTimeChange(value, fname) {
        if (fname === "startTime") {
            setformData({ ...formData, [fname]: value.format().slice(0, 17) + "01.000Z" });
        }
        else {
            setformData({ ...formData, [fname]: value.format().slice(0, 17) + "00.000Z" });
        }
    }
    function editShiftTimeChange(value, fname) {
        let temp = value.format().slice(0, 17);
        let h = parseInt(temp.slice(11, 13));
        let m = parseInt(temp.slice(14, 16));
        setEditTime({ ...editTime, [fname]: moment().hour(h).minute(m) })
        setCurrentData({ ...currentData, [fname]: temp + ".000Z" });
        if (fname === "startTime") {
            setCurrentData({ ...currentData, [fname]: temp + "01.000Z" });
        }
        else {
            setCurrentData({ ...currentData, [fname]: temp + "00.000Z" });
        }
    }

    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);

    const handleClose = () => {
        setSiteErrorMsg({})
        setShow(false);
    }
    const handleShow = () => {
        setSites([]);
        setShow(true);
    }

    const handleClose1 = () => {
        setShow1(false);
        setSiteEditErrorMsg({});
    }

    const [loader, setLoader] = useState(true);
    let [allAccount, setAllAccount] = useState([]);
    let [sites, setSites] = useState([]);
    let [formData, setformData] = useState({
        accountID: "",
        siteID: "",
        shiftName: "",
        startTime: "0000-00-00T00:00:00.000",
        endTime: "0000-00-00T00:00:00.000",
        isActive: true
    });
    let [currentData, setCurrentData] = useState({
        accountID: "",
        siteID: "",
        shiftName: "",
        startTime: "0000-00-00T00:00:00.000",
        endTime: "0000-00-00T00:00:00.000",
    });


    useEffect(() => {
        getAllRoles();
        getAllAccountData();
    }, [])


    function getAllAccountData() {
        fetch(environment.baseUrl + "getAccounts?", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setAllAccount(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setAllAccount([]);
                }
            })
        })
    }
    function getSiteByAccountId(accId) {
        fetch(environment.baseUrl + "getSiteByAccID", {
            method: "Post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({ "accountID": accId })
        }).then((result) => {
            result.json().then((res) => {
                if (res.code == 200) {
                    setSites(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setSites([]);
                }
            })

        })
    }

    function saveShiftData() {
        let accID = JSON.parse(sessionStorage.getItem('accountID'))
        fetch(environment.baseUrl + "addShift?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                accountID: accID,
                siteID: formData.siteID,
                shiftName: formData.shiftName,
                startTime: formData.startTime,
                endTime: formData.endTime,
                isActive: true
            })
        }).then((result) => {
            result.json().then((res) => {
                handleClose();
                setAlert({
                    msg: res.msg,
                    status: true
                });
                if (res.code == 200) {
                    getShiftForOpoerator();
                    if (formData.siteID === asset.siteID) {
                        getShiftBySite(asset.siteID);
                        if (asset.opeType === "edit") {
                            if (asset.apiSiteID === asset.siteID) {
                                getShiftByEquipment(asset.assetID);
                            }
                        }
                    }
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                setformData({
                    accountID: "",
                    siteID: "",
                    shiftName: "",
                    startTime: "0000-00-00T00:00:00.000",
                    endTime: "0000-00-00T00:00:00.000",
                    isActive: true
                });
            })
        })
    }
    function updateShiftData() {
        fetch(environment.baseUrl + "updateShift/" + currentData.shiftID, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(currentData)
        }).then((result) => {
            result.json().then((res) => {
                handleClose1();
                setAlert({
                    msg: res.msg,
                    status: true
                });
                if (res.code == 200) {
                    getShiftForOpoerator();
                    if (currentData.siteID === asset.siteID) {
                        getShiftBySite(asset.siteID);
                        if (asset.opeType === "edit") {
                            if (asset.apiSiteID === asset.siteID) {
                                getShiftByEquipment(asset.assetID);
                            }
                        }
                    }
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                setCurrentData({
                    accountID: "",
                    siteID: "",
                    shiftName: "",
                    startTime: "",
                    endTime: "",
                });
            })
        })
    }
    let [editTime, setEditTime] = useState({
        startTime: moment().hour(0).minute(0),
        endTime: moment().hour(0).minute(0)
    });
    function getShftById(id) {
        fetch(environment.baseUrl + "shifts/" + id, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        })
            .then((apiRes) => {
                apiRes.json().then((resp) => {
                    getSiteByAccountId(resp.data.result[0].accountID);
                    setCurrentData(resp.data.result[0]);
                    let sh = parseInt((resp.data.result[0].startTime).slice(11, 13));
                    let sm = parseInt((resp.data.result[0].startTime).slice(14, 16));
                    let eh = parseInt((resp.data.result[0].endTime).slice(11, 13));
                    let em = parseInt((resp.data.result[0].endTime).slice(14, 16));
                    setEditTime({
                        startTime: moment().hour(sh).minute(sm),
                        endTime: moment().hour(eh).minute(em)
                    })
                    setLoader(false);
                })
            })
    }
    function editShiftData(shiftId) {
        setLoader(true);
        setCurrentData({
            accountID: "",
            siteID: null,
            shiftName: "",
            startTime: "",
            endTime: "",
        });
        setShow1(true);
        getShftById(shiftId);
    }
    let [error, setError] = useState("");
    function getFormData(e) {
        let string = e.target.value;
        if (string.length >= 25) {
            setError(true);
        } else {
            setError(false);
        }
        if (e.target.name === "siteID") {
            setformData({ ...formData, [e.target.name]: parseInt(e.target.value) });
        }
        else if (e.target.name === 'endTime' || e.target.name === 'startTime') {
            let date = new Date();
            let today;
            var dd = String(date.getDate()).padStart(2, '0');
            var mm = String(date.getMonth() + 1).padStart(2, '0');
            var yyyy = date.getFullYear();
            today = yyyy + "-" + mm + "-" + dd + "T" + e.target.value + ":00.000";
            setformData({ ...formData, [e.target.name]: today });
        }
        else {
            setformData({ ...formData, [e.target.name]: e.target.value });
            if (e.target.name == "accountID") {
                getSiteByAccountId(e.target.value);
            }
        }
    }
    function getEditFormData(e) {
        if (e.target.name === 'endTime' || e.target.name === 'startTime') {
            let date = new Date();
            let today;
            var dd = String(date.getDate()).padStart(2, '0');
            var mm = String(date.getMonth() + 1).padStart(2, '0');
            var yyyy = date.getFullYear();
            today = yyyy + "-" + mm + "-" + dd + "T" + e.target.value + ":00.000Z";
            setCurrentData({ ...currentData, [e.target.name]: today });
        }
        else {
            setCurrentData({ ...currentData, [e.target.name]: e.target.value });
        }
    }

    // =======================================================
    //               END SHIFT 
    // ======================================================


    // =======================================================
    //             OPERATOR
    // ======================================================
    const [show2, setShow2] = useState(false);
    function handleOperatorClose() {
        setOperatorShift1([]);
        setOperatorErrorMsg1({});
        setOperatorErrorMsg({});
        setShow2(false);
        setOperator({
            operatorName: "",
            licenceID: "",
            licenceExpiryDate: "",
            licenceValdity: "",
            isActive: true,
            assetID: "",
            shiftID: [],
            apiShiftIDs: [],
            opeType: "",
            operatorID: "",
            accountID: ""
        });
        setOpSelect([]);
        setOpApishift([]);
    }
    const handleOperatorShow = (optype) => {
        setShow2(true);
        setOperator({ ...operator, opeType: optype });
    }
    let [operator, setOperator] = useState({
        operatorName: "",
        licenceID: "",
        licenceExpiryDate: "",
        licenceValdity: "",
        isActive: true,
        assetID: "",
        shiftID: [],
        apiShiftIDs: [],
        opeType: "",
        operatorID: "",
        accountID: ""
    });
    let [opApishift, setOpApishift] = useState([]);
    let [opSelect, setOpSelect] = useState([]);
    function checkOpSelect(val) {
        if (val.length <= 3) {
            setOpSelect(val)
        }
    }
    useEffect(() => {
        let arr = [];
        opSelect.map(e => (arr.push(e.value)));
        setOperator({ ...operator, shiftID: arr });
    }, [opSelect])

    let [operatorShift, setOperatorShift] = useState([]);
    function getShiftForOpoerator() {
        let accID = JSON.parse(sessionStorage.getItem("accountID"))
        fetch(environment.baseUrl + "getShiftBySite", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "accountID": accID
            })
        }).then((result) => {
            result.json().then((res) => {
                if (res.code == 200) {
                    setOperatorShift(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setOperatorShift([]);
                }
            })
        })
    }
    let [shiftBlank, setShiftBlank] = useState(false);
    let [operatorShift1, setOperatorShift1] = useState([]);
    function getShiftByEquipment1(assetID, siteID) {
        fetch(environment.baseUrl + "getExcludedShiftBySite", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                assetID: assetID,
                siteID: siteID,
                accountID: assetIdData.accountID
            })
        }).then((apiRes) => {
            apiRes.json().then((res) => {
                if (res.code == 200) {
                    setOperatorShift1(res.data.result)
                    if (res.data.result.length === 0) {
                        setShiftBlank(true);
                    }
                    else {
                        setShiftBlank(false);
                    }
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setOperatorShift1([]);
                }
            })
        })
    }

    let [OperatorByAcc, setOperatorByAcc] = useState([]);
    function getOperatorByAcc() {
        let accID = JSON.parse(sessionStorage.getItem("accountID"));
        fetch(environment.baseUrl + "getOperatorByAccount?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "accountID": accID,
                "assetID": JSON.parse(sessionStorage.getItem("assetID"))
            })
        })
            .then((apiRes) => {
                apiRes.json().then((resp) => {
                    if (resp.code == 200) {
                        setOperatorByAcc(resp.data.result);
                    }
                    else if (resp.code == 401) {
                        setSessOut(true);
                    }
                    else {
                        setOperatorByAcc([]);
                    }
                })
            })
    }
    let [showOpeShift, setShowOpeShift] = useState(false);
    let [opeShiftData, setOpeShiftData] = useState([]);
    function getShiftByOperatorID(opeId, type, assetId) {
        fetch(environment.baseUrl + "getShiftByOperatorID", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                operatorID: opeId,
                assetID: assetId
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setOpeShiftData(resp.data.result);
                    if (type == "edit") {
                        let shiftObj = [], apArr = [];
                        resp.data.result.forEach(element => {
                            apArr.push(element.shiftID);
                            shiftObj.push({ label: element.shiftName, value: element.shiftID })
                        });
                        setOpSelect(shiftObj);
                        setOpApishift(apArr);
                    }
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setOpeShiftData([]);
                }
            })
        });
    }

    function showOpeShifts(operatorID, assetId) {
        getShiftByOperatorID(operatorID, "", assetId);
        setShowOpeShift(true);
    }
    function editOperatorData(curretOp) {
        let siteId = null;
        for (let index = 0; index < equipmentByAccount.length; index++) {
            if (equipmentByAccount[index].assetID === curretOp.assetID) {
                siteId = equipmentByAccount[index].siteID;
                break;
            }
        }

        getShiftByOperatorID(curretOp.operatorID, "edit", curretOp.assetID);
        getShiftByEquipment1(curretOp.assetID, siteId);
        setOperator({
            ...operator,
            operatorName: curretOp.operatorName,
            licenceID: curretOp.licenceID,
            licenceExpiryDate: (curretOp.licenceExpiryDate).slice(0, 10),
            licenceValdity: curretOp.licenceValdity,
            isActive: true,
            assetID: curretOp.assetID,
            opeType: "edit",
            operatorID: curretOp.operatorID,
            accountID: curretOp.accountID,
        });
        setShow2(true);
    }
    function setAddRemoveShifts() {
        let removeItem = opApishift.filter((o) => operator.shiftID.indexOf(o) === -1);
        let addItem = operator.shiftID.filter((o) => opApishift.indexOf(o) === -1);
        return (
            {
                removeItem: removeItem,
                addItem: addItem
            }
        )
    }
    function updateOperatorData() {
        let obj = setAddRemoveShifts();
        fetch(environment.baseUrl + "updateOperatorAssetMapping?", {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                accountID: operator.accountID,
                operatorID: operator.operatorID,
                operatorName: operator.operatorName,
                licenceID: operator.licenceID,
                licenceExpiryDate: operator.licenceExpiryDate,
                isActive: operator.isActive,
                assetID: operator.assetID,
                removeShiftID: obj.removeItem,
                addShiftID: obj.addItem
            })
        }).then((result) => {
            result.json().then((res) => {
                setAlert({
                    msg: res.msg,
                    status: true
                });
                if (res.code == 200) {
                    getOperatorByAcc();
                    handleOperatorClose();
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })
        })
    }
    let [equipmets, setEquipments] = useState([
        {
            assetID: ""
        }
    ])

    function getOperatorFormData(e) {
        if (e.target.name == "assetID") {
            setOperatorShift1([]);
            setOpSelect([]);
            setOpeShiftData([]);
            let siteID = equipmentByAccount[e.target.selectedIndex - 1].siteID
            getShiftByEquipment1(e.target.value, siteID)
        }

        if (e.target.name == "licenceValdity") {
            setOperator({ ...operator, [e.target.name]: e.target.value, licenceExpiryDate: e.target.value });

        }
        else {
            setOperator({ ...operator, [e.target.name]: e.target.value });
            setoperatorError(false);
        }
    }
    let [operatorError, setoperatorError] = useState("");
    function saveOperatorFormData() {
        let accID = JSON.parse(sessionStorage.getItem("accountID"))
        fetch(environment.baseUrl + "createOperatorAssetMapping?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                accountID: accID,
                operatorName: operator.operatorName,
                licenceID: operator.licenceID,
                licenceExpiryDate: operator.licenceExpiryDate,
                licenceValdity: operator.licenceValdity,
                assetID: operator.assetID,
                shiftID: operator.shiftID
            })
        }).then((result) => {
            result.json().then((res) => {
                handleOperatorClose();
                setAlert({
                    msg: res.msg,
                    status: true
                });
                if (res.code == 200) {
                    getOperatorByAcc();
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })
        })
    }

    // =======================================================
    //               END OPERATOR 
    // ======================================================

    //////////////////////////////////// for preventive start /////////////////////////////////////////////////

    let [pmArr, setPMobj] = useState({
        reading1: "",
        reading2: "",
        reading3: "",
        readOnly: false,
        updateBtn: false
    });
    let [listAllPM, setlistAllPM] = useState([]);

    function listPM() {
        fetch(environment.baseUrl + "listPMAccount", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                accountID: JSON.parse(sessionStorage.getItem('accountID')),
                assetID: JSON.parse(sessionStorage.getItem('assetID')),
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    if (resp.data.result.length) {
                        if (resp.data.result[0][0]["preventive"].length) {
                            setPMobj({
                                reading1: resp.data.result[0][0]["preventive"][0].pmReading,
                                reading2: resp.data.result[0][0]["preventive"][1].pmReading,
                                reading3: resp.data.result[0][0]["preventive"][2].pmReading,
                                readOnly: true,
                                updateBtn: true
                            });
                            setlistAllPM(resp.data.result[0][0]["preventive"]);
                        }
                        else {
                            setPMobj({
                                reading1: "",
                                reading2: "",
                                reading3: "",
                                readOnly: false,
                                updateBtn: false
                            });
                            setlistAllPM([]);
                        }
                    }
                    else {
                        setPMobj({
                            reading1: "",
                            reading2: "",
                            reading3: "",
                            readOnly: false,
                            updateBtn: false
                        });
                        setlistAllPM([]);
                    }
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setPMobj({
                        reading1: "",
                        reading2: "",
                        reading3: "",
                        readOnly: false,
                        updateBtn: false
                    });
                    setlistAllPM([]);
                }
            })
        })
    }

    function setPMFormData(e) {
        setPMobj({ ...pmArr, [e.target.name]: e.target.value })
    }
    let [pmErrorMsg, setPmErrorMsg] = useState({});
    function validatePmData() {
        let errror = {};

        if (pmArr.reading1 == "") {
            errror.reading1 = "This field is required";
        } else if (parseInt(pmArr.reading1) < 0) {
            errror.reading1 = "Enter only positive number";
        }

        if (pmArr.reading2 == "") {
            errror.reading2 = "This field is required";
        } else if (parseInt(pmArr.reading2) < 0) {
            errror.reading2 = "Enter only positive number";
        }

        if (pmArr.reading3 == "") {
            errror.reading3 = "This field is required";
        } else if (parseInt(pmArr.reading3) < 0) {
            errror.reading3 = "Enter only positive number";
        }

        setPmErrorMsg(errror);

        if (Object.keys(errror).length == 0) {
            if (pmArr.updateBtn) {
                updatePMData();
            }
            else {
                submitPM();
            }
        }
        else {
        }
    }
    function submitPM() {
        fetch(environment.baseUrl + "addPreventiveMaintenance?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                assetID: JSON.parse(sessionStorage.getItem('assetID')),
                accountID: JSON.parse(sessionStorage.getItem('accountID')),
                pmData: [{
                    status: "Due",
                    title: "1st Preventive Maintenance",
                    reading: pmArr.reading1,
                    pmNumber: 1,
                },
                {
                    status: "Due",
                    title: "2nd Preventive Maintenance",
                    reading: pmArr.reading2,
                    pmNumber: 2,
                },
                {
                    status: "Due",
                    title: "3rd Preventive Maintenance",
                    reading: pmArr.reading3,
                    pmNumber: 3,
                }
                ]

            })
        }).then((result) => {
            result.json().then(res => {
                setAlert({
                    msg: res.msg,
                    status: true
                });
                if (res.code == 200) {
                    listPM();
                    clearPM();
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })
        })

    }
    function updatePMData() {
        fetch(environment.baseUrl + "updatePreventiveMaintenance?", {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                assetID: JSON.parse(sessionStorage.getItem('assetID')),
                accountID: JSON.parse(sessionStorage.getItem('accountID')),
                pmData: [
                    {
                        reading: pmArr.reading1,
                        maintenanceID: listAllPM[0].maintenanceID,
                        pmNumber: 1,
                    },
                    {
                        reading: pmArr.reading2,
                        maintenanceID: listAllPM[1].maintenanceID,
                        pmNumber: 2,
                    },
                    {
                        reading: pmArr.reading3,
                        maintenanceID: listAllPM[2].maintenanceID,
                        pmNumber: 3,
                    },
                ]
            })
        }).then((result) => {
            result.json().then(res => {
                setAlert({
                    msg: res.msg,
                    status: true
                });
                if (res.code == 200) {
                    listPM();
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })
        })
    }
    function clearPM() {
        setPMobj({ ...pmArr, readOnly: true });
    }
    //////////////////////////////////// for preventive end /////////////////////////////////////////////////



    function convertDate(fulltime) {
        if (fulltime != null) {
            let yy = fulltime.slice(0, 4);
            let mm = fulltime.slice(5, 7);
            let dd = fulltime.slice(8, 10);
            return (dd + "-" + mm + "-" + yy);
        }
    }
    function convertDateTime(fulltime) {
        let date = new Date(fulltime);
        const local = moment.utc(date).local().format();
        if (fulltime != null) {
            let yy = local.slice(0, 4);
            let mm = local.slice(5, 7);
            let dd = local.slice(8, 10);
            let time = local.slice(11, 16);
            return (dd + "-" + mm + "-" + yy + " " + time);
        }
    }

    // for preventive
    let [tabClass, setTabClass] = useState("disaled-tab-menu");
    let [activeTab, setActiveTab] = useState("first");

    function validateTabSwitch(tab) {
        if (assetIdData.assetID != "") {
            if (assetIdData.assetExist == false && tab == "sixth" || assetIdData.assetExist == false && tab == "seventh") {
                setAlert({
                    msg: "Please onboard the asset first",
                    status: true
                });
            }
            else {
                setActiveTab(tab)
            }
        }
        else {
            setTabClass("disaled-tab");
            console.error("Please enter equipment serial no. first or entered no. not found");
            setAlert({
                msg: "Please enter equipment serial no. first or entered no. not found",
                status: "true"
            })
        }
    }
    let [assetErrorMsg, setAssetErrorMsg] = useState({});
    function assetValidate() {
        const numbRegex = /^(0|[1-9]\d*)$/;
        let errror = {};
        if (asset.assetID == "") {
            errror.assetID = "This field is required";
        }
        if (asset.assetID.length > 25) {
            errror.assetID = "Exceeded 25 character limits";
        }

        if (asset.deviceID == "") {
            errror.deviceID = "This field is required";
        }
        if (asset.deviceID.length > 40) {
            errror.deviceID = "Exceeded 40 character limits";
        }
        if (asset.hh === "") {
            errror.meterReading = "This field is required";
        }
        else if (parseInt(asset.hh) < 0) {
            errror.meterReading = "Enter positive value only";
        }
        else if ((asset.hh).includes("-") || (asset.hh).includes(".")) {
            errror.meterReading = "Enter positive whole value only";
        }
        else if (asset.mm == "" || parseInt(asset.mm) < 0 || parseInt(asset.mm) > 59 || (asset.mm).includes("-") || (asset.mm).includes(".")) {
            errror.meterReading = "Enter minute value between 0-59";
        }
        else if (asset.ss == "" || parseInt(asset.ss) < 0 || parseInt(asset.ss) > 59 || (asset.ss).includes("-") || (asset.ss).includes(".")) {
            errror.meterReading = "Enter second value between 0-59";
        }

        else if (parseInt(asset.hourMeterReadingAtInstallation) < 0) {
            errror.hourMeterReadingAtInstallation = "Enter only positive number";
        }
        if (asset.productDescription == "") {
            errror.productDescription = "This field is required";
        }
        if (asset.fuelType == "") {
            errror.fuelType = "This field is required";
        }
        if (asset.comissioningDate == "") {
            errror.comissioningDate = "This field is required";
        }
        if (asset.coverageDate == "") {
            errror.coverageDate = "This field is required";
        }
        if (asset.warrantyDate == "") {
            errror.warrantyDate = "This field is required";
        }

        if (asset.manufactureDate == "") {
            errror.manufactureDate = "This field is required";
        }

        if (asset.subscriptionPlan == "") {
            errror.subscriptionPlan = "This field is required";
        }
        else if (asset.subscriptionPlan.length > 25) {
            errror.subscriptionPlan = "Exceeded 25 character limits";
        }
        else if ((asset.subscriptionPlan).includes("-") || (asset.subscriptionPlan).includes(".")) {
            errror.subscriptionPlan = "Enter only positive whole number";
        }

        if (asset.subscriptionTire == "") {
            errror.subscriptionTire = "This field is required";
        }
        if (asset.subscriptionTire.length > 25) {
            errror.subscriptionTire = "Exceeded 25 character limits";
        }
        if (asset.subscriptionStartDate == "") {
            errror.subscriptionStartDate = "This field is required";
        }
        if (asset.subscriptionEndDate == "") {
            errror.subscriptionEndDate = "This field is required";
        }
        if (asset.siteID == "") {
            errror.siteID = "This field is required";
        }
        if (asset.shiftID == "") {
            errror.shiftID = "This field is required";
        }

        if (asset.isRentalOfIoT == null) {
            errror.isRentalOfIoT = "This field is required";
        }
        if (asset.rentalOfIoTScheme == "") {
            errror.rentalOfIoTScheme = "This field is required";
        }
        if (asset.rentalOfIoTScheme.length > 25) {
            errror.rentalOfIoTScheme = "Exceeded 25 character limits";
        }
        setAssetErrorMsg(errror);
        // console.log("asset",asset)
        if (Object.keys(errror).length == 0) {
            if (asset.opeType === "edit") {
                updateAssetData();
            }
            else {
                saveAssetFrom();
            }
        }
    }

    let [errorMsg, setErrorMsg] = useState({});
    function assetUserValidate() {
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const phoneRegex = /^[0]?[6789]\d{9}$/;

        let errror = {};
        if (info.roleID == null) {
            errror.roleID = "This field is required";
        }
        if (info.firstName == "") {
            errror.firstName = "This field is required";
        }
        if (info.firstName.length > 25) {
            errror.firstName = "Exceeded 25 characters limit";
        }

        if (info.lastName == "") {
            errror.lastName = "This field is required";
        }
        if (info.lastName.length > 25) {
            errror.lastName = "Exceeded 25 characters limit";
        }

        if (info.mobileNo == "") {
            errror.mobileNo = "This field is required";
        }
        else if (info.mobileNo.match(phoneRegex)) {
        }
        else {
            errror.mobileNo = "Enter valid mobile number";
        }

        if (info.mobileNo != "" && info.mobileNo.length > 10 || info.mobileNo != "" && info.mobileNo.length < 10) {
            errror.mobileNo = "Enter valid mobile number";
        }
        if (isNaN(info.mobileNo)) {
            errror.mobileNo = "Mobile number must be in digit";
        }

        if (info.siteID == null) {
            errror.siteID = "This field is required";
        }
        if (info.emailID == "") {
            errror.emailID = "This field is required";
        }
        else if (info.emailID.match(emailRegex)) {
        }
        else {
            errror.emailID = "Enter valid email format";
        }

        setErrorMsg(errror);
        if (Object.keys(errror).length == 0) {
            if (info.optype == "edit") {
                updateAccountUser();
            }
            else {
                saveAccountUserForm();
            }
        }
        else {
        }
    }
    let [siteErrorMsg, setSiteErrorMsg] = useState({});
    function shiftValidate() {
        let errror = {};
        if (formData.siteID == "") {
            errror.siteID = "This field is required";
        }
        if (formData.shiftName == "") {
            errror.shiftName = "This field is required";
        }
        if (formData.shiftName.length > 25) {
            errror.shiftName = "Exceeded 25 characters limit";
        }

        if (formData.startTime == "0000-00-00T00:00:00.000") {
            errror.startTime = "This field is required";
        }
        if (formData.endTime == "0000-00-00T00:00:00.000") {
            errror.endTime = "This field is required";
        }


        setSiteErrorMsg(errror);
        if (Object.keys(errror).length == 0) {
            saveShiftData();
        }
    }
    let [siteEditErrorMsg, setSiteEditErrorMsg] = useState({});
    function SiteEditValidate() {
        //console.log("formdatavalidate", formData)
        let errror = {};
        if (currentData.siteID == "") {
            errror.siteID = "This field is required";
        }
        if (currentData.shiftName == "") {
            errror.shiftName = "This field is required";
        }
        else if (currentData.shiftName.length > 25) {
            errror.shiftName = "Exceeded 25 characters limit";
        }

        if (currentData.startTime == "0000-00-00T00:00:00.000") {
            errror.startTime = "This field is required";
        }
        if (currentData.endTime == "0000-00-00T00:00:00.000") {
            errror.endTime = "This field is required";
        }


        setSiteEditErrorMsg(errror);
        if (Object.keys(errror).length == 0) {
            updateShiftData();
        }
    }
    let [operatorErrorMsg, setOperatorErrorMsg] = useState({});
    function OperatorValidate() {
        let errror = {};
        if (operator.operatorName == "") {
            errror.operatorName = "This field is required";
        }
        if (operator.operatorName.length > 25) {
            errror.operatorName = "Exceeded 25 characters limit";
        }
        if (operator.assetID == "") {
            errror.assetID = "This field is required";
        }
        if (operator.licenceExpiryDate == "") {
            errror.licenceExpiryDate = "This field is required";
        }

        if (operator.licenceID == "") {
            errror.licenceID = "This field is required";
        }
        if (operator.licenceID.length > 25) {
            errror.licenceID = "Exceeded 25 characters limit";
        }
        if (operator.shiftID.length == 0) {
            errror.shiftID = "This field is required";
        }
        setOperatorErrorMsg(errror);
        if (Object.keys(errror).length == 0) {
            saveOperatorFormData();
        }

    }
    let [operatorErrorMsg1, setOperatorErrorMsg1] = useState({});
    function ValidateUpdateFormData() {
        let errror = {};
        if (operator.assetID == "") {
            errror.assetID = "This field is required";
        }
        if (operator.shiftID.length == 0) {
            errror.shiftID = "This field is required";
        }
        setOperatorErrorMsg1(errror);
        if (Object.keys(errror).length == 0) {
            updateOperatorData();
        }
    }
    const [value, onChange] = useState('10:00');


    // SITE DATATABLE COLUMNS
    const columns_site = useMemo(
        () => [
            {
                Header: 'Site Name',
                accessor: 'siteName',
            },
            {
                Header: 'Working Days per Week ',
                accessor: 'view',
            },

            {
                Header: 'Action',
                accessor: 'action',
            }
        ],
        []
    )

    // USER DATATABLE COLUMNS
    const columns_user = useMemo(
        () => [
            {
                Header: 'Role',
                accessor: 'roleName',
            },
            {
                Header: 'First Name ',
                accessor: 'firstName',
            },
            {
                Header: 'Last Name',
                accessor: 'lastName',
            },
            {
                Header: 'Phone No. ',
                accessor: 'phoneNumber',
            },
            {
                Header: 'Email ID',
                accessor: 'emailID',
            },
            {
                Header: 'Widget Allowed Group',
                accessor: 'groupName',
            },
            {
                Header: 'Site',
                accessor: 'siteName',
            },
            {
                Header: 'Status',
                accessor: 'isActive',
            },
            {
                Header: 'Action',
                accessor: 'action',
            }
        ],
        []
    )

    // SHIFT DATATTABLE COLUMSN
    const columns_shift = useMemo(
        () => [
            {
                Header: 'Account Name',
                accessor: 'accountName',
            },
            {
                Header: 'Site Name ',
                accessor: 'siteName',
            },
            {
                Header: 'Shift',
                accessor: 'shiftName',
            },
            {
                Header: 'Start Time',
                accessor: 'startTime',
            },
            {
                Header: 'End Time',
                accessor: 'endTime',
            },
            {
                Header: 'Action',
                accessor: 'action',
            }
        ],
        []
    )

    // OPERATOR DATATABLE COLUMNS
    const columns_operator = useMemo(
        () => [
            {
                Header: 'Operator Name',
                accessor: 'operatorName',
            },
            {
                Header: 'License Number',
                accessor: 'licenceID',
            },
            {
                Header: 'Validity Status',
                accessor: 'validityStatus',
            },
            {
                Header: 'License Expiry Date',
                accessor: 'licenceExpiryDate',
            },
            {
                Header: 'Equipment ID',
                accessor: 'assetID',
            },
            {
                Header: 'Shift',
                accessor: 'view',
            },
            {
                Header: 'Create Date Time',
                accessor: 'createdDateTime',
            },
            {
                Header: 'Update Date Time',
                accessor: 'updatedDateTime',
            }
            ,
            {
                Header: 'Action',
                accessor: 'action',
            }
        ]
    )

    return (
        <div className='main-container'>
            <SessionFun show={sessOut}></SessionFun>
            <Alert obj={malert} />
            <h4 className='main-heading'>Asset Onboarding</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;
                <i className='fa fa-angle-right'></i></Link>&nbsp; Asset Onboarding</p>

            {/* tab */}

            <div className="row">
                <Tabs className={tabClass} defaultActiveKey="first" activeKey={activeTab} onSelect={(key) => validateTabSwitch(key)}>
                    <Tab eventKey="first" title="Asset Details">
                        <div className="mt-3 card-box-block">
                            <h6 className='cardtitle'></h6>
                            <div className="row">
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Equipment Serial No.<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control ref={eqsrnoRef} type="text" name='assetID' style={{ border: "1px solid #0077b9" }} value={asset.assetID} className="textbox-back" onChange={getAssetFormData} placeholder="Enter Equipment Serial No." readOnly={params.assetInfoId ? (JSON.parse(params.assetInfoId)).type == "edit" ? true : false : false} />
                                        {
                                            assetIdData.assetExist == true ?
                                                <small className='red'>Equipment already onboarded.</small>
                                                :
                                                assetIdData.assetExist === "no" ?
                                                    <small className='red'>Entered Serial no. not found</small>
                                                    :
                                                    ""
                                        }
                                        <small className='red'>{assetErrorMsg.assetID}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Telematics Device ID<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="text" name='deviceID' value={asset.deviceID} onChange={getAssetFormData} className="textbox-back" placeholder="Enter Telematics Device ID" maxLength="40" />
                                        {

                                            deviceExist ? <small className='red'>Device ID already exists.</small> : ""

                                        }
                                        <small className='red'>{assetErrorMsg.deviceID}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Hour Meter Reading (At Installation)<span style={{ color: "red" }}>*</span></Form.Label>
                                        <div className="row">
                                            <div className="col-sm-3  full-col"><Form.Control type="number" name='hh' value={asset.hh} onChange={getAssetFormData} className="textbox-back" placeholder="0" /></div>
                                            <div className="col-sm-1 colun-box">:</div>
                                            <div className="col-sm-3 full-col"><Form.Control type='number' className="textbox-back" placeholder="MM" name='mm' value={asset.mm} onChange={getAssetFormData}></Form.Control></div>
                                            <div className="col-sm-1 colun-box">:</div>
                                            <div className="col-sm-3 full-col"><Form.Control type='number' className="textbox-back" placeholder="SS" name='ss' value={asset.ss} onChange={getAssetFormData}></Form.Control></div>
                                        </div>
                                        <small className='red'>{assetErrorMsg.meterReading}</small>
                                    </Form.Group>
                                </div>

                            </div>
                            {/* Row 2 */}
                            <div className="row mt-3">
                                <div className="col-sm-4 left-col" >
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Product Category<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="text" name='productCategory' value={assetIdData.productCategory} className="textbox-back" placeholder="Product Category" readOnly />
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4 ">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Product Sub-Category<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="text" name='productSubCategory' value={assetIdData.productSubCategory} className="textbox-back" placeholder="Product Sub-Category" readOnly />
                                    </Form.Group>
                                </div>
                            </div>
                            {/* ROW 3 */}
                            <div className="row mt-3">
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Product Description<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Select name='productDescription' value={asset.productDescription} onChange={getAssetFormData} className="textbox-back" aria-label="Default select example">
                                            <option value="">Select Product Description</option>
                                            {
                                                productDescription.map((item, index) =>
                                                    <option key={index} value={item.description}>{item.description}</option>
                                                )
                                            }
                                        </Form.Select>
                                        <small className='red'>{assetErrorMsg.productDescription}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Equipment Type<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Select name='fuelType' value={asset.fuelType} onChange={getAssetFormData} className="textbox-back" aria-label="Default select example">
                                            <option value="">Select Equipment type</option>
                                            {
                                                (dropdownData.asset_equipmentType).map((item, index) =>
                                                    <option key={index} value={item.name}>{item.name}</option>
                                                )
                                            }
                                        </Form.Select>
                                        <small className='red'>{assetErrorMsg.fuelType}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4 ">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Date of Commissioning<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="date" name='comissioningDate' placeholder="dd-mm-yyyy" value={asset.comissioningDate} onChange={getAssetFormData} className="textbox-back" />
                                        <small className='red'>{assetErrorMsg.comissioningDate}</small>
                                    </Form.Group>
                                </div>
                            </div>

                            {/* Row 4 */}
                            <div className="row mt-3">
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Date of Manufacture<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="date" name='manufactureDate' value={asset.manufactureDate} onChange={getAssetFormData} className="textbox-back" placeholder="1" />
                                        <small className='red'>{assetErrorMsg.manufactureDate}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Subscription Plan Years<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="number" name='subscriptionPlan' value={asset.subscriptionPlan} onChange={getAssetFormData} className="textbox-back" placeholder="Enter Subscription Plan Years" />
                                        <small className='red'>{assetErrorMsg.subscriptionPlan}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4 ">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Subscription Tier<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="text" name='subscriptionTire' value={asset.subscriptionTire} onChange={getAssetFormData} className="textbox-back" placeholder="Enter Subscription Tier" />
                                        <small className='red'>{assetErrorMsg.subscriptionTire}</small>
                                    </Form.Group>
                                </div>
                            </div>
                            {/* Row 5 */}
                            <div className="row mt-3">
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Subscription Start Date<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="date" name='subscriptionStartDate' value={asset.subscriptionStartDate} onChange={getAssetFormData} className="textbox-back" placeholder="1" />
                                        <small className='red'>{assetErrorMsg.subscriptionStartDate}</small>
                                    </Form.Group>
                                </div>

                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Subscription End Date<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="date" name='subscriptionEndDate' value={asset.subscriptionEndDate} min={asset.subscriptionStartDate} onChange={getAssetFormData} className="textbox-back" placeholder="1" />
                                        <small className='red'>{assetErrorMsg.subscriptionEndDate}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4 ">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Select Site<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Select name='siteID' value={asset.siteID} onChange={getAssetFormData} className="textbox-back">
                                            <option value="">Select Site</option>
                                            {
                                                siteList.map((item, index) =>
                                                    <option key={index} value={item.siteID}>{item.siteName}</option>
                                                )
                                            }
                                        </Form.Select>
                                        <small className='red'>{assetErrorMsg.siteID}</small>
                                    </Form.Group>
                                </div>

                            </div>
                            {/* Row 6 */}
                            <div className="row mt-3">
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-3" >
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Select Shift<span className='red'>*</span>
                                                {
                                                    shiftOverlap ? <small className='red'>&nbsp;(Note: Other shifts are overlapping)</small>
                                                        : ""
                                                }
                                            </Form.Label>
                                            <MultiSelect
                                                options={assetshifts}
                                                value={selectShifts}
                                                onChange={setSelectShifts}
                                                labelledBy="Select Shifts"
                                                valueRenderer={valueRenderer}
                                                hasSelectAll={false}
                                                className='textbox-back'
                                            />
                                            <small className='red'>{assetErrorMsg.shiftID}</small>
                                        </Form.Group>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Select Users</Form.Label>
                                        <MultiSelect
                                            options={userBySite.map(e => ({ label: e.firstName, value: e.userID }))}
                                            value={selected}
                                            onChange={setSelected}
                                            valueRenderer={valueRenderer}
                                            labelledBy="Select"
                                            hasSelectAll={false}
                                        />
                                    </Form.Group>
                                </div>
                                {
                                    params.assetInfoId ?
                                        <div className="col-sm-4 ">
                                            <Form.Group className="mb-2" >
                                                <Form.Label>Rental of IOT<span style={{ color: "red" }}>*</span></Form.Label>
                                            </Form.Group>
                                            <input type="radio" onChange={getAssetFormData} value="1" name="isRentalOfIoT" checked={asset.isRentalOfIoT == true} /> Yes
                                            <input className='ms-5' onChange={getAssetFormData} type="radio" value="0" name="isRentalOfIoT" checked={asset.isRentalOfIoT == false} /> No<br />
                                            <small className='red'>{assetErrorMsg.isRentalOfIoT}</small>
                                        </div>
                                        :
                                        <div className="col-sm-4">
                                            <Form.Group className="mb-2" >
                                                <Form.Label>Rental of IOT<span style={{ color: "red" }}>*</span></Form.Label>
                                            </Form.Group>
                                            <input type="radio" onChange={getAssetFormData} name="isRentalOfIoT" value="1" /> Yes
                                            <input className='ms-5' onChange={getAssetFormData} type="radio" value="0" name="isRentalOfIoT" /> No<br />
                                            <small className='red'>{assetErrorMsg.isRentalOfIoT}</small>
                                        </div>
                                }

                            </div>
                            {/* Row 7 */}
                            <div className="row mt-3">
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Rental IOT Scheme<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="text" name='rentalOfIoTScheme' value={asset.rentalOfIoTScheme} onChange={getAssetFormData} className="textbox-back" placeholder="Enter Rental IOT Scheme" />
                                        <small className='red'>{assetErrorMsg.rentalOfIoTScheme}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Under Warranty Till Date<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="date" name='warrantyDate' value={asset.warrantyDate} onChange={getAssetFormData} className="textbox-back" />
                                        <small className='red'>{assetErrorMsg.warrantyDate}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Under Coverage Till Date<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="date" name='coverageDate' className="textbox-back" value={asset.coverageDate} onChange={getAssetFormData} />
                                        <small className='red'>{assetErrorMsg.coverageDate}</small>
                                    </Form.Group>
                                </div>
                            </div>

                            {/* Row 9 */}
                            <div className="row mt-3">
                                <div className="col-sm-7 left-col">
                                    <button className="btn btn-light light-btn me-2" onClick={() => validateTabSwitch("second")}>Add Site</button>
                                    <button className="btn btn-light light-btn me-2" onClick={() => validateTabSwitch("third")}>Add User</button>
                                    <button className="btn btn-light light-btn" onClick={() => validateTabSwitch("fourth")}>Add Shift</button>
                                </div>
                                <div className="col-sm-5">
                                    {
                                        params.assetInfoId ?
                                            // (JSON.parse(params.assetInfoId)).type == "edit" ? //old
                                            params.opType == "01" ?
                                                <button className="ad-btn btn-save  float-end" onClick={assetValidate} disabled={deviceExist}>
                                                    Update Asset
                                                </button>
                                                :
                                                <button className="add-btn btn-save  float-end" onClick={assetValidate} disabled={assetIdData.assetExist}>
                                                    Add Asset
                                                </button>
                                            :
                                            <button className="add-btn btn-save  float-end" onClick={assetValidate} disabled={assetIdData.assetExist}>
                                                Add Asset
                                            </button>
                                    }

                                    {
                                        params.assetInfoId ?
                                            <button onClick={() => navigate('/assets-lists')} className="btn btn-outline-secondary  float-end me-3">Cancel</button>
                                            :
                                            ""
                                    }
                                </div>
                            </div>
                            {/* </Form> */}
                        </div>
                    </Tab>
                    <Tab eventKey="second" title="Account Associated">
                        <div className="mt-3 card-box-block">
                            <h6 className='cardtitle'>Account Details</h6>
                            <Form>
                                {/* Row 1 */}
                                <div className="row">
                                    <div className="col-sm-4 left-col">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Account ID</Form.Label>
                                            <Form.Control readOnly type="text" value={assetIdData.accountID} className="textbox-back" placeholder="Account Code" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Account Name</Form.Label>
                                            <Form.Control readOnly type="text" value={assetIdData.accountName} className="textbox-back" placeholder="Account Name" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Is Key Account</Form.Label>
                                            <Form.Control readOnly type="text" value={assetIdData.isKeyAccount} className="textbox-back" placeholder="Is Key Account" />
                                        </Form.Group>
                                    </div>
                                </div>
                                {/* Row 2 */}
                                <div className="row mt-3">
                                    <div className="col-sm-4 left-col">

                                        <Form.Group className="mb-3" >
                                            <Form.Label>Industry</Form.Label>
                                            <Form.Control readOnly type="text" value={assetIdData.industry} className="textbox-back" placeholder="Industry" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Service Branch</Form.Label>
                                            <Form.Control readOnly type="text" value={assetIdData.serviceBranch} className="textbox-back" placeholder="Service Branch" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Sales Branch</Form.Label>
                                            <Form.Control readOnly type="text" value={assetIdData.salesBranch} className="textbox-back" placeholder="Sales Branch" />
                                        </Form.Group>
                                    </div>
                                </div>
                                {/* Row 3 */}
                                <div className="row mt-3">
                                    <div className="col-sm-4 left-col">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Service Dealer</Form.Label>
                                            <Form.Control readOnly type="text" value={assetIdData.serviceDealer} className="textbox-back" placeholder="Service Dealer" />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Form>
                        </div>


                        <div className='mt-3 card-box-block'>
                            <h6 className='cardtitle'>Site</h6>
                            <Table_site columns={columns_site} data={siteList} addfun={setAddSiteModel} editFun={editSite} viewFun={showWorkDays} />
                        </div>
                        {/* for add/edit site popUp */}
                        <Modal show={addSiteShow} onHide={handleAddSiteClose} centered backdrop="static" size="lg">
                            <Modal.Header>
                                <Modal.Title>{site.opeType == "edit" ? "Edit Site" : "Add Site"}</Modal.Title>
                                <button onClick={handleAddSiteClose} type="button" className="close">
                                    <img src={close} alt="" />
                                </button>
                            </Modal.Header>
                            <Modal.Body className=' logout-box'>
                                {/* Row 1 */}
                                <div className="row mt-3">
                                    <div className="col-sm-4 left-col">

                                        <Form.Group className="mb-3" >
                                            <Form.Label>Add Site<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control type="text" className="textbox-back" value={site.siteName} onChange={(e) => setSite({ ...site, siteName: e.target.value })} placeholder="Enter Site" />
                                            <small className='red'>{accAssociatederrorMsg.siteName}</small>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">

                                        <Form.Label>Working Days per Week<span style={{ color: "red" }}>*</span></Form.Label>
                                        <MultiSelect
                                            options={daysArr.map(e => ({ label: e.label, value: e.value, }))}
                                            value={selectedDay}
                                            onChange={setSelectedDay}
                                            labelledBy="Select"
                                            valueRenderer={valueRenderer}
                                        />
                                        <small className='red'>{accAssociatederrorMsg.workDay}</small>
                                    </div>
                                    <div className="col-sm-4 mt-4">
                                        <button className="add-btn btn-save  float-end mt-2" onClick={accAssociatedValidate}>
                                            {site.opeType == "edit" ? "Update" : "Save"}
                                        </button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* for add site popUp */}
                        {/*view working days MODAL */}
                        <Modal show={showDays} onHide={() => { setShowDays(false); setWorkDays([]) }} centered backdrop="static" >
                            <Modal.Header>
                                <Modal.Title>Site</Modal.Title>
                                <button onClick={() => { setShowDays(false); setWorkDays([]) }} type="button" className="close">
                                    <img src={close} alt="" />
                                </button>
                            </Modal.Header>
                            <Modal.Body className=' logout-box'>
                                <table className="table">
                                    <thead className='table-secondary'>
                                        <tr>
                                            <th >Working days</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            (workDays).map((item, index) =>
                                                <tr key={index}>
                                                    <td>{item.workingDay}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>

                                <div className="row justify-content-end mt-3">
                                    <button className="btn btn-outline-secondary lo-btn  float-end"
                                        onClick={() => { setShowDays(false); setWorkDays([]) }}>
                                        Cancel
                                    </button>
                                </div>
                                {/* </Form> */}
                            </Modal.Body>
                        </Modal>
                        {/* MODAL ENDS */}

                    </Tab>
                    <Tab eventKey="third" title="Account Users">
                        <div className=" mt-3 card-box-block">
                            <h6 className='cardtitle'>Users List</h6>
                            <Table_user columns={columns_user} data={userByAccount} addFun={setAddUserModel} editFun={editAccountUser} viewFun={showUsersDashboardName} />
                        </div>
                        <Modal show={addUserShow} onHide={handleAddUserClose} centered backdrop="static" size="lg">
                            <Modal.Header>
                                <Modal.Title>{info.optype == "edit" ? "Edit User" : "Add Users"}</Modal.Title>
                                <button onClick={handleAddUserClose} type="button" className="close">
                                    <img src={close} alt="" />
                                </button>
                            </Modal.Header>
                            <Modal.Body className=' logout-box'>
                                {/* Row 1 */}
                                <div className="row">
                                    <div className="col-sm-4 left-col">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Role<span style={{ color: "red" }}>*</span></Form.Label>
                                            {/* <Form.Select name="roleID" as="select" className="textbox-back" placeholder="Role" value={info.roleID} onChange={getAccountUserFormData} disabled={info.optype == "edit" ? true : false}> */}
                                            <Form.Select name="roleID" as="select" className="textbox-back" placeholder="Role" value={info.roleID} onChange={getAccountUserFormData}>
                                                <option value="">Select Role</option>
                                                {
                                                    allRole.map((item, index) =>
                                                        <option key={index} value={item.roleID}>{item.roleName}</option>
                                                    )
                                                }
                                            </Form.Select>
                                            <small className='red'>{errorMsg.roleID}</small>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>First Name<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control name="firstName" type="text" className="textbox-back" placeholder="First Name" value={info.firstName} onChange={getAccountUserFormData} />
                                            {/* <Form.Control name="firstName" type="text" className="textbox-back" placeholder="First Name" value={info.firstName} onChange={getAccountUserFormData} readOnly={info.optype == "edit" ? true : false} /> */}
                                            <small className='red'>{errorMsg.firstName}</small>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Last Name<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control name="lastName" type="text" className="textbox-back" placeholder="Last Name" value={info.lastName} onChange={getAccountUserFormData} />
                                            {/* <Form.Control name="lastName" type="text" className="textbox-back" placeholder="Last Name" value={info.lastName} onChange={getAccountUserFormData} readOnly={info.optype == "edit" ? true : false} /> */}
                                            <small className='red'>{errorMsg.lastName}</small>
                                        </Form.Group>
                                    </div>
                                </div>
                                {/* Row 2 */}
                                <div className="row mt-3">
                                    <div className="col-sm-4 left-col">

                                        <Form.Group className="mb-3" >
                                            <Form.Label>Phone Number<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control name="mobileNo" type="text" className="textbox-back" maxLength="10" placeholder="Phone Number" value={info.mobileNo} onChange={getAccountUserFormData} />
                                            <small className='red'>{errorMsg.mobileNo}</small>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Email Id<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control name="emailID" type="text" className="textbox-back" placeholder="Email Id" value={info.emailID} onChange={getAccountUserFormData} readOnly={info.optype == "edit" ? true : false} />
                                            <small className='red'>{errorMsg.emailID}</small>
                                        </Form.Group>
                                    </div>

                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label> Select Site<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Select as="select" name='siteID' className="textbox-back" value={info.siteID} onChange={getAccountUserFormData} disabled={info.optype == "edit" ? true : false}>
                                                <option value="">Select Site</option>
                                                {
                                                    siteList.map((item, index) =>
                                                        <option key={index} value={item.siteID}>{item.siteName}</option>
                                                    )
                                                }
                                            </Form.Select>
                                            <small className='red'>{errorMsg.siteID}</small>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-sm-4 left-col">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Widgets Group allowed</Form.Label>
                                            <Form.Select name="groupID" as="select" className="textbox-back" aria-label="Default select example" value={info.groupID} onChange={getAccountUserFormData}>
                                                <option value="">Open this select menu</option>
                                                {
                                                    dashboardGroupList.map((item, index) =>
                                                        <option key={index} value={item.groupID}>{item.groupName}</option>
                                                    )
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                    {
                                        info.optype == "edit" ?
                                            <div className="col-sm-4">
                                                <Form.Group className="mb-3" >
                                                    <Form.Label>Status<span style={{ color: "red" }}>*</span></Form.Label>
                                                    <Form.Select name="isActive" as="select" className="textbox-back" aria-label="Default select example" value={info.isActive} onChange={getAccountUserFormData}>
                                                        <option value="true">Active</option>
                                                        <option value="false">Inactive</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </div>
                                            :
                                            <div className="col-sm-4">
                                                <Form.Group className="mb-3" >
                                                    <Form.Label>Status<span style={{ color: "red" }}>*</span></Form.Label>
                                                    <Form.Control name="isActive" type="text" className="textbox-back" placeholder="Email Id" value={"Active"} readOnly={true} />
                                                </Form.Group>
                                            </div>
                                    }

                                </div>
                                {/* Row 3 */}
                                <div className="row">
                                    <div className="col-sm-4 left-col">

                                    </div>
                                    <div className="col-sm-4">

                                    </div>
                                    <div className="col-sm-4 mt-4">
                                        <button className="add-btn btn-save  float-end mt-2" onClick={assetUserValidate}>
                                            {info.optype == "edit" ? "Update" : "Save"}
                                        </button>
                                    </div>
                                </div>
                                {/* </Form> */}
                            </Modal.Body>
                        </Modal>
                        {/* for add user popUp */}

                        <Modal show={showudashName} onHide={() => setShowUdashName(false)} centered backdrop="static" >
                            <Modal.Header>
                                <Modal.Title>{udashName.userName}</Modal.Title>
                                <button onClick={() => setShowUdashName(false)} type="button" className="close">
                                    <img src={close} alt="" />
                                </button>
                            </Modal.Header>
                            <Modal.Body className=' logout-box'>
                                <table className="table">
                                    <thead className='table-secondary'>
                                        <tr>
                                            <th >Dashboard Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            udashName.data.map((item, index) =>
                                                <tr key={index}>
                                                    <td>{item.dashboardName}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>

                                <div className="row justify-content-end">
                                    <button className="btn btn-outline-secondary lo-btn  float-end" onClick={() => setShowUdashName(false)}>
                                        Cancel
                                    </button>
                                </div>
                                {/* </Form> */}
                            </Modal.Body>
                        </Modal>
                    </Tab>
                    <Tab eventKey="fourth" title="Shift">
                        <div className="card-box-block mt-3">
                            <h6 className='cardtitle'>Shift</h6>
                            <Table_shift columns={columns_shift} data={operatorShift} addFun={handleShow} editFun={editShiftData} />
                        </div>

                        <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
                            <Modal.Header>
                                <Modal.Title>Add Shift</Modal.Title>
                                <button onClick={handleClose} type="button" className="close">
                                    <img src={close} alt="" />
                                </button>
                            </Modal.Header>
                            <Modal.Body className=' logout-box'>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Select Site<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Select as="select" name='siteID' className="textbox-back" onChange={getFormData}>
                                                <option value="">Select Site</option>
                                                {
                                                    siteList.map((item, index) =>
                                                        <option key={index} value={item.siteID}>{item.siteName}</option>
                                                    )
                                                }
                                            </Form.Select>
                                            <small className='red'>{siteErrorMsg.siteID}</small>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-6">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Enter Shift Name<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control type="text" name='shiftName' className="textbox-back" onChange={getFormData} />
                                            <small className='red'>{siteErrorMsg.shiftName}</small>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <Form.Group className="mb-3" >
                                            <Form.Label> Start Time<span style={{ color: "red" }}>*</span></Form.Label>
                                            <TimePicker
                                                showSecond={false}
                                                className="form-control textbox-back"
                                                onChange={(e) => addShiftTimeChange(e, "startTime")}
                                                format={format}
                                                minuteStep={5}
                                                use12Hours
                                                inputReadOnly
                                                placeholder="Shift Start Time"
                                            />
                                            <small className='red'>{siteErrorMsg.startTime}</small>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-6">
                                        <Form.Group className="mb-3" >
                                            <Form.Label> End Time<span style={{ color: "red" }}>*</span></Form.Label>
                                            <TimePicker
                                                showSecond={false}
                                                className="form-control textbox-back"
                                                onChange={(e) => addShiftTimeChange(e, "endTime")}
                                                format={format}
                                                minuteStep={5}
                                                use12Hours
                                                inputReadOnly
                                                placeholder="Shift End Time"
                                            />
                                            <small className='red'>{siteErrorMsg.endTime}</small>
                                        </Form.Group>
                                    </div>

                                </div>
                                <div className="row text-center mt-3">
                                    <div className="col-sm-6">
                                        <button className="btn btn-outline-secondary lo-btn  float-end" onClick={handleClose}>
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col-sm-6">
                                        <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={shiftValidate}>
                                            Save
                                        </button>
                                    </div>
                                </div>
                                {/* </Form> */}
                            </Modal.Body>
                        </Modal>
                        {/* edit screen */}
                        <Modal show={show1} onHide={handleClose1} centered backdrop="static" size="lg">
                            <Modal.Header>
                                <Modal.Title>Edit Shift</Modal.Title>
                                <button onClick={handleClose1} type="button" className="close">
                                    <img src={close} alt="" />
                                </button>
                            </Modal.Header>
                            <Modal.Body className='logout-box'>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Select Account</Form.Label>
                                            <Form.Select disabled as="select" name='accountID' value={currentData.accountID} className="textbox-back" onChange={getFormData}>
                                                <option value="">Select Account</option>
                                                {
                                                    allAccount.map((item, index) =>
                                                        <option key={index} value={item.accountID}>{item.accountName}</option>
                                                    )
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Select Site</Form.Label>
                                            <Form.Control disabled as="select" name='siteID' value={currentData.siteID} className="textbox-back" onChange={getFormData}>
                                                <option value="">Select Site</option>
                                                {
                                                    sites.map((item, index) =>
                                                        <option key={index} value={item.siteID}>{item.siteName}</option>
                                                    )
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Enter Shift Name</Form.Label>
                                            <Form.Control type="text" name='shiftName' value={currentData.shiftName} className="textbox-back" onChange={getEditFormData} />
                                            <small className='red'>{siteEditErrorMsg.shiftName}</small>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Shift Start Time</Form.Label>
                                            <TimePicker
                                                value={editTime.startTime}
                                                showSecond={false}
                                                className="form-control textbox-back"
                                                onChange={(e) => editShiftTimeChange(e, "startTime")}
                                                format={format}
                                                minuteStep={5}
                                                use12Hours
                                                inputReadOnly
                                                placeholder="Shift Start Time"
                                                disabled
                                            />
                                            <small className='red'>{siteEditErrorMsg.startTime}</small>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Shift End Time</Form.Label>
                                            <TimePicker
                                                value={editTime.endTime}
                                                showSecond={false}
                                                className="form-control textbox-back"
                                                onChange={(e) => editShiftTimeChange(e, "endTime")}
                                                format={format}
                                                minuteStep={5}
                                                use12Hours
                                                inputReadOnly
                                                placeholder="Shift End Time"
                                                disabled
                                            />
                                            <small className='red'>{siteEditErrorMsg.endTime}</small>
                                        </Form.Group>
                                    </div>

                                </div>
                                <div className="row text-center mt-3">
                                    <div className="col-sm-6">
                                        <button className="btn btn-outline-secondary lo-btn  float-end" onClick={handleClose1}>
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col-sm-6">
                                        <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={SiteEditValidate}>
                                            Update
                                        </button>
                                    </div>
                                </div>
                                {/* </div> */}
                            </Modal.Body>
                        </Modal>
                    </Tab>

                    <Tab eventKey="fifth" title="Operator">
                        <div className="card-box-block mt-3">
                            <h6 className='cardtitle'>Operator</h6>
                            <Table_ope data={OperatorByAcc} addFun={handleOperatorShow} editFun={editOperatorData} viewFun={showOpeShifts} />
                        </div>

                        <Modal show={show2} onHide={handleOperatorClose} centered backdrop="static" size="lg">
                            <Modal.Header>
                                <Modal.Title>{operator.opeType == "add" ? "Add Operator" : "Edit Operator"}</Modal.Title>
                                <button onClick={handleOperatorClose} type="button" className="close">
                                    <img src={close} alt="" />
                                </button>
                            </Modal.Header>
                            <Modal.Body className=' logout-box'>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Operator Name<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control type='text' placeholder='Operator name' name='operatorName' className="textbox-back"
                                                value={operator.operatorName} onChange={getOperatorFormData} readOnly={operator.opeType == "add" ? false : true} />
                                            <small className='red'>{operatorErrorMsg.operatorName}</small>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Equipment<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Select name='assetID' value={operator.assetID} ref={opAssetRef}
                                                onChange={getOperatorFormData} className="textbox-back">
                                                <option value="">Select Equipment</option>
                                                {
                                                    equipmentByAccount.map((item, index) =>
                                                        <option key={index} value={item.assetID}>{item.assetID}</option>
                                                    )
                                                }
                                            </Form.Select>
                                            <small className='red'>{operatorErrorMsg.assetID}</small>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Shifts<span style={{ color: "red" }}>*</span>
                                                {
                                                    shiftBlank ? <small className='red'>&nbsp;(Shifts are already allocated)</small> : ""
                                                }
                                            </Form.Label>
                                            <MultiSelect
                                                options={
                                                    operator.opeType == "add" ?
                                                        operatorShift1.map(e => ({ label: e.shiftName, value: e.shiftID }))
                                                        :
                                                        (operatorShift1.concat(opeShiftData)).map(e => ({ label: e.shiftName, value: e.shiftID }))
                                                }
                                                value={opSelect}
                                                onChange={checkOpSelect}
                                                labelledBy="Select Shifts"
                                                valueRenderer={valueRenderer}
                                            />
                                            <small className='red'>Max 3 Shifts allowed*</small>
                                            <small className='red'>&nbsp;{operatorErrorMsg.shiftID ? "," + operatorErrorMsg.shiftID : null}</small>
                                            <small className='red'>&nbsp;{operatorErrorMsg1.shiftID ? "," + operatorErrorMsg1.shiftID : null}</small>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>License Validity(Date)<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control type='date' min={moment().format('YYYY-MM-DD')} placeholder='License Number' name='licenceExpiryDate'
                                                value={operator.licenceExpiryDate} onChange={getOperatorFormData} className="textbox-back" />
                                            <small className='red'>{operatorErrorMsg.licenceExpiryDate}</small>
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Operator License Number<span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control type='text' placeholder='License Number' name='licenceID'
                                                value={operator.licenceID} onChange={getOperatorFormData} className="textbox-back" readOnly={operator.opeType == "add" ? false : true} />
                                            <small className='red'>{operatorErrorMsg.licenceID}</small>
                                        </Form.Group>
                                    </div>

                                </div>
                                <div className="row text-center mt-3">
                                    <div className="col-sm-6">
                                        <button className="btn btn-outline-secondary lo-btn  float-end" onClick={handleOperatorClose}>
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col-sm-6">
                                        {
                                            operator.opeType == "add" ?
                                                <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={OperatorValidate} >
                                                    Save
                                                </button>
                                                :
                                                <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={ValidateUpdateFormData}>
                                                    Update
                                                </button>
                                        }
                                    </div>
                                </div>
                                {/* </Form> */}
                            </Modal.Body>
                        </Modal>

                        <Modal show={showOpeShift} onHide={() => setShowOpeShift(false)} centered backdrop="static" >
                            <Modal.Header>
                                <Modal.Title> Shifts</Modal.Title>
                                <button onClick={() => setShowOpeShift(false)} type="button" className="close">
                                    <img src={close} alt="" />
                                </button>
                            </Modal.Header>
                            <Modal.Body className=' logout-box'>
                                <table className="table">
                                    <thead className='table-secondary'>
                                        <tr>
                                            <th >Shifts</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            opeShiftData.map((item, index) =>
                                                <tr key={index}>
                                                    <td>{item.shiftName}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>

                                <div className="row justify-content-end mt-3">
                                    <button className="btn btn-outline-secondary lo-btn  float-end"
                                        onClick={() => setShowOpeShift(false)}>
                                        Cancel
                                    </button>
                                </div>
                                {/* </Form> */}
                            </Modal.Body>
                        </Modal>

                    </Tab>
                    <Tab eventKey="sixth" title="Threshold">
                        <div className="mt-3 card-box-block">
                            <h6 className='cardtitle'>Set Threshold</h6>
                            <div className="row">
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Target Utilisation (%)</Form.Label>
                                        <Form.Control type="number" step="0.01" name='targetUtilization' value={threshold.targetUtilization} onChange={getThresholdFormData} readOnly={threshold.readOnly} className="textbox-back" placeholder='Target Utilisation' />
                                        <small className='red'>{tsErrorMsg.targetUtilization}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Fuel Level (%)</Form.Label>
                                        <Form.Control type="number" step="0.01" name="fuelLevel" onChange={getThresholdFormData} readOnly={threshold.readOnly} value={threshold.fuelLevel} className="textbox-back" placeholder="Fuel Level" />
                                        <small className='red'>{tsErrorMsg.fuelLevel}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Battery Level (%)</Form.Label>
                                        <Form.Control type="number" step="0.01" name="batteryLevel" onChange={getThresholdFormData} readOnly={threshold.readOnly} value={threshold.batteryLevel} className="textbox-back" placeholder="Battery Level" />
                                        <small className='red'>{tsErrorMsg.batteryLevel}</small>
                                    </Form.Group>
                                </div>
                            </div>
                            {/* Row 2 */}
                            <div className="row mt-3">
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Volt Meter</Form.Label>
                                        <Form.Control type="number" step="0.01" name="voltMeter" value={threshold.voltMeter} readOnly={threshold.readOnly} onChange={getThresholdFormData} className="textbox-back" placeholder="Volt Meter" />
                                        <small className='red'>{tsErrorMsg.voltMeter}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Max Coolant Temperature</Form.Label>
                                        <Form.Control type="number" step="0.01" name="coolentTemprature" value={threshold.coolentTemprature} readOnly={threshold.readOnly} onChange={getThresholdFormData} className="textbox-back" placeholder="Max Coolant Temperature" />
                                        <small className='red'>{tsErrorMsg.coolentTemprature}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Min Coolant Temperature</Form.Label>
                                        <Form.Control type="number" step="0.01" name="minCT" value={threshold.minCT} readOnly={threshold.readOnly} onChange={getThresholdFormData} className="textbox-back" placeholder="Min Coolant Temperature" />
                                        <small className='red'>{tsErrorMsg.minCT}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Max Engine Oil Pressure</Form.Label>
                                        <Form.Control type="number" step="0.01" name="engineOilPressure" value={threshold.engineOilPressure} readOnly={threshold.readOnly} onChange={getThresholdFormData} className="textbox-back" placeholder="Max Engine Oil Pressure" />
                                        <small className='red'>{tsErrorMsg.engineOilPressure}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Min Engine Oil Pressure</Form.Label>
                                        <Form.Control type="number" step="0.01" name="minEOP" value={threshold.minEOP} readOnly={threshold.readOnly} onChange={getThresholdFormData} className="textbox-back" placeholder="Min Engine Oil Pressure" />
                                        <small className='red'>{tsErrorMsg.minEOP}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>G-Force</Form.Label>
                                        <Form.Control type="number" step="0.01" name="gForce" value={threshold.gForce} readOnly={threshold.readOnly} onChange={getThresholdFormData} className="textbox-back" placeholder="G-Force" />
                                        <small className='red'>{tsErrorMsg.gForce}</small>
                                    </Form.Group>
                                </div>
                            </div>

                            {/* Row 3 */}
                            <div className="row mt-3 justify-content-end">

                                <button type='cancel' onClick={clearThreshold} className="btn btn-outline-secondary lo-btn me-3" >
                                    Cancel
                                </button>
                                {
                                    threshold.readOnly ?
                                        <button className="add-btn btn-save  confirm-btn" onClick={() => setThreshold({ ...threshold, readOnly: false })} >
                                            Edit
                                        </button>
                                        :
                                        <button className="add-btn btn-save  confirm-btn" onClick={validateTsData} >
                                            {threshold.updateBtn ? "Update" : "Save"}
                                        </button>
                                }
                            </div>
                        </div>

                    </Tab>
                    <Tab eventKey="seventh" title="Preventive Maintenance">
                        <div className="mt-3 card-box-block">
                            <h6 className='cardtitle'>Add PM Records</h6> {/* Row 1 */}
                            <div className="row mt-3">
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>1st PM reading Hrs</Form.Label>
                                        <Form.Control type="number" className="textbox-back"
                                            name="reading1" onChange={setPMFormData} placeholder="Enter" value={pmArr.reading1} readOnly={listAllPM.length ? listAllPM[0].status == "Serviced" ? true : pmArr.readOnly : pmArr.readOnly} />
                                        <small className='red'>{pmErrorMsg.reading1}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>2nd PM reading Hrs</Form.Label>
                                        <Form.Control type="number" className="textbox-back"
                                            name="reading2" onChange={setPMFormData} placeholder="Enter" value={pmArr.reading2} readOnly={listAllPM.length ? listAllPM[1].status == "Serviced" ? true : pmArr.readOnly : pmArr.readOnly} />
                                        <small className='red'>{pmErrorMsg.reading2}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-3" >
                                        <Form.Label>3rd PM reading Hrs</Form.Label>
                                        <Form.Control type="number" className="textbox-back"
                                            name="reading3" onChange={setPMFormData} placeholder="Enter" value={pmArr.reading3} readOnly={listAllPM.length ? listAllPM[2].status == "Serviced" ? true : pmArr.readOnly : pmArr.readOnly} />
                                        <small className='red'>{pmErrorMsg.reading3}</small>
                                    </Form.Group>
                                </div>
                            </div> {/* Row 3 */}
                            <div className="row mt-3 justify-content-end">


                                <button className="btn btn-outline-secondary lo-btn me-3 " onClick={clearPM}>Cancel</button>

                                {
                                    pmArr.readOnly ?
                                        <button className="add-btn btn-save  confirm-btn" onClick={() => setPMobj({ ...pmArr, readOnly: false })} >
                                            Edit
                                        </button>
                                        :
                                        <button className="add-btn btn-save  confirm-btn" onClick={validatePmData} >
                                            {pmArr.updateBtn ? "Update" : "Save"}
                                        </button>
                                }

                            </div>
                        </div>
                        <div className="row mt-3 card-box-block">
                            <h6 className='cardtitle'>PM List</h6>
                            <div className="table-responsive">
                                <table className="table">
                                    <thead className='table-secondary'>
                                        <tr>
                                            <th style={{ whiteSpace: 'nowrap' }} scope="col">Preventive Maintenance</th>
                                            <th style={{ whiteSpace: 'nowrap' }} scope="col">Status</th></tr>
                                    </thead>
                                    <tbody>
                                        {
                                            listAllPM.map((item, index) =>
                                                <tr key={index}>
                                                    <td>{item.title}</td>
                                                    <td>{item.status}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Tab>
                </Tabs>
            </div>
        </div>
    )
}

export default Asset_Customer_Form
